define('viewmodels/RaSocialization/SocializationResponseOld',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'viewmodels/landing', 'services/utils', 'viewmodels/RaSocialization/Administration'],
    function (ko, router, app, appsecurity, navigation, system, logger, SurveyDashBoard, utils, Administration) {
        var SrViewModel = {
            activate: activate,
            attached: attached,
            appsecurity: appsecurity,
            utils: utils,
            SurveyDashBoard: SurveyDashBoard,
            Administration: Administration,
            PageHeaderName: ko.observable(),
            BusinessUnitId: ko.observable(),
            BusinessUnitName: ko.observable(),
            SurveyTypesList: ko.observable(),
            RootTabList: ko.observable(),
            AssessmentTypeId: ko.observable(),
            SurveyActionsList: ko.observableArray([]),
            SurveyActionsListValidation: ko.observable([]),
            SurveyId: ko.observable(),
            SurveyTypeId: ko.observable(),
            inhHeatMapDataList: ko.observableArray([]),
            inhHeatMapDataListDUP: ko.observableArray([]),
            cntrlHeatMapDataList: ko.observableArray([]),
            residualHeatMapDataList: ko.observableArray([]),
            cntrlHeatMapDataListDUP: ko.observableArray([]),
            residualHeatMapDataListDUP: ko.observableArray([]),
            inhHeatMapFinalData: ko.observable(),
            inhHeatMapFinalDataDUP: ko.observable(),
            cntrlHeatMapFinalData: ko.observable(),
            residualHeatMapFinalData: ko.observable(),
            inhHeatMapDrpDwn: ko.observableArray(),
            cntrlHeatMapDrpDwn: ko.observableArray(),
            resHeatMapDrpDwn: ko.observableArray(),
            inhFactorHeatMapDrpDwn: ko.observableArray(),
            OverrideCommentsCharsLimit: ko.observable(4000),
            OverrideCommentsChars: ko.observable(4000),
            overrideCommentsDetails: ko.observable(),
            overrideRequestList: ko.observableArray(),
            overrideRequestListRecal: ko.observableArray(),
            overrideActionList: ko.observableArray(),
            approveDenyDetails: ko.observable(),
            overrideCommentsList: ko.observable(),
            OcKeypress: OcKeypress,
            OcKeyUp: OcKeyUp,
            expandCollapseColumns: ko.observableArray([]),
            OVERRIDE_FLAG: ko.observable(),
            APPROVER_FLAG: ko.observable(),
            AssignmentReadOnlyFlag: ko.observable(false),
            readOnlyFlag: ko.observable(false),
            createTab: createTab,
            NavigateToAssignment: NavigateToAssignment,
            NavigateToDashboard: NavigateToDashboard,
            ResponseMoveArray: ko.observable(),
            tabType: ko.observable(''),
            surveyDetails: ko.observable(),
            GetActions: GetActions,
            expandCollapseAll: expandCollapseAll,
            heatMapView: ko.observable(false),
            heatMapViewNA: ko.observable(false),
            heatMapSwitch: heatMapSwitch,
            heatMapSwitchNA: heatMapSwitchNA,
            expandCollapse: ko.observable('C'),
            contentTabVisible: ko.observable(),
            executiveSummaryDetails: ko.observable(),
            ExportExecutiveSummary: ExportExecutiveSummary,
            GetAllExecutiveSummary: GetAllExecutiveSummary,
            SubmitExecutiveSummary: SubmitExecutiveSummary,
            ResetExecutiveSummary: ResetExecutiveSummary,
            DataTableColumnWidth: ko.observable('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'),
            addEditOverrideComment: addEditOverrideComment,
            btnClickPerformAction: btnClickPerformAction,
            showInhHeatMap: ko.observable(false),
            showCntrlHeatMap: ko.observable(false),
            showResdHeatMap: ko.observable(false),
            TaxonomyLevelList: ko.observableArray([]),
            TaxonomyTypeSelected: TaxonomyTypeSelected,
            SelectedTaxonomyOption: ko.observable(),
            StatusPopUpClick: StatusPopUpClick,
            btnCloseStatusPopup: btnCloseStatusPopup,
            workflowModelList: ko.observableArray([]),
            ColorApproved: ko.observable('blue'),
            ColorDenied: ko.observable('black'),
            ColorPending: ko.observable('grey'),
            FileExtension: ko.observable('.pdf'),
            SSId: ko.observable(0),
            InhRiskDriversText: ko.observable(),
            CntrlRiskDriversText: ko.observable(),
            OtherRiskDriversText: ko.observable(),
            KeyMethodologyText: ko.observable(),
            WarningInfoLebel: ko.observable(''),
            ControlNarratives: ko.observableArray([]),
            ResetContrlNarratives: ResetContrlNarratives,
            SubmitNarratives: SubmitNarratives,
            InherentNarratives: ko.observableArray([]),
            SubmitInherentNarratives: SubmitInherentNarratives,
            OrgLevelFlag: ko.observable(true),
            OrgAUConlspan: ko.observable(5),
            DistinctRiskLevelList: ko.observableArray([]),
            ClickedSurveyType: ko.observable(0),
            ClickedSurveyTypeText: ko.observable('qldr'),
            QualResponseListData: ko.observableArray([]),
            valuechange: valuechange,
            RemoveArray: ko.observableArray([]),
            ControlColumnDetails: ko.observableArray([]),
            QualColumnDetails: ko.observableArray([]),
            tabTypeDetails: ko.observableArray([]),
            SearchResult: SearchResult,
            ResetSearch: ResetSearch,
            Query: ko.observable(''),
            ControlsResponseData: ko.observableArray([]),
            ClickedQualType: ko.observable('qualitative'),
            FormatValueData: FormatValueData,
            CheckInherentQuestion: CheckInherentQuestion,
            CheckControlQuestion: CheckControlQuestion,
            ResetInhNarratives: ResetInhNarratives,
            OverrideRequestSSRS: OverrideRequestSSRS,
            User: ko.observable(),
            ErrorChars: ko.observable(''),
            ToggleNavigationMenu1: ToggleNavigationMenu1,
            ToggleNavigationMenu2: ToggleNavigationMenu2,
            CollapseAllTreeView: CollapseAllTreeView,
            ExpandAllTreeView: ExpandAllTreeView,
            SearchTreeView: SearchTreeView,
            BreadCrumbArray: ko.observableArray([]),
            AreaLeveljstree: ko.observableArray([]),
            isAllSubCategorySurveyCompleteFlag: ko.observable(),
            isSaveResponseClick: ko.observable(false),
            selectedTreeNode: ko.observableArray([]),
            SurveyTypeClicked: ko.observable(),
            Zat_id_Tree: ko.observable(),
            Type: ko.observable(),
            ClickedRiskAreaId: ko.observable(),
            ClickedRiskAreaName: ko.observable(),
            TaxonomyLevelListFlag: ko.observable(false),
            SelectedTaxonomyOptionFlag: ko.observable(false),
            GetHeatmapDataForTaxonomy: GetHeatmapDataForTaxonomy,
            FormatValueDataLevel: FormatValueDataLevel,
            valuechangeLevel: valuechangeLevel,
            SelectedTaxonomyOptionText: ko.observable(''),
            DisplayExportDropdown: DisplayExportDropdown,
            RecalculateAccordionClick: RecalculateAccordionClick,
            RequestedQAAccordionClick: RequestedQAAccordionClick,
            NavigateToSocioExportReport: NavigateToSocioExportReport,
            inhHeatMapDataListDUPRaw: ko.observableArray([]),
            residualHeatMapDataListDUPRaw: ko.observableArray([]),
            cntrlHeatMapDataListDUPRaw: ko.observableArray([]),
            NavigateToSocioHistoricExportReport: NavigateToSocioHistoricExportReport,
            SelectedTaxonomyOptionRefresh: ko.observable(),
            ChangesTabClick: ko.observable(false)
        };
        return SrViewModel;
        function activate() {
            if (SrViewModel.Administration.ResponseMoveArray() != undefined && appsecurity.SocializationReadOnly() == true) {
                SrViewModel.AssignmentReadOnlyFlag(true);
                SrViewModel.appsecurity.WriteAccess('false');
                SrViewModel.PageHeaderName(SrViewModel.Administration.ResponseMoveArray().BusinessUnitName());
                SrViewModel.BusinessUnitName(SrViewModel.Administration.ResponseMoveArray().BusinessUnitName());
                SrViewModel.BusinessUnitId(SrViewModel.Administration.ResponseMoveArray().BusinessUnitId());
                SrViewModel.SurveyId(SrViewModel.Administration.ResponseMoveArray().SurveyId());
                SrViewModel.SurveyTypeId(SrViewModel.Administration.ResponseMoveArray().SurveyTypeId());
                SrViewModel.OVERRIDE_FLAG(SrViewModel.Administration.ResponseMoveArray().OVERRIDE_FLAG());
                SrViewModel.APPROVER_FLAG(SrViewModel.Administration.ResponseMoveArray().APPROVER_FLAG());
                SrViewModel.readOnlyFlag(SrViewModel.Administration.ResponseMoveArray().ReadOnly_FLAG());
                SrViewModel.AssessmentTypeId(SrViewModel.Administration.ResponseMoveArray().RatId());
                SrViewModel.SelectedTaxonomyOptionFlag(false);
            }
            else if (SrViewModel.SurveyDashBoard.ResponseMoveArray() != undefined && appsecurity.SocializationReadOnly() == false) {
                SrViewModel.AssignmentReadOnlyFlag(false);
                SrViewModel.appsecurity.WriteAccess('true');
                SrViewModel.PageHeaderName(SrViewModel.SurveyDashBoard.ResponseMoveArray().BusinessUnitName());
                SrViewModel.BusinessUnitName(SrViewModel.SurveyDashBoard.ResponseMoveArray().BusinessUnitName());
                SrViewModel.BusinessUnitId(SrViewModel.SurveyDashBoard.ResponseMoveArray().BusinessUnitId());
                SrViewModel.readOnlyFlag(SrViewModel.SurveyDashBoard.ResponseMoveArray().ReadOnly_FLAG());
                SrViewModel.AssessmentTypeId(SrViewModel.SurveyDashBoard.ResponseMoveArray().RatId());
                SrViewModel.SelectedTaxonomyOptionFlag(false);
            }
            else if (SrViewModel.SurveyDashBoard.ResponseMoveArray() == undefined && appsecurity.SocializationReadOnly() == false) {
                router.navigate("RaSocialization/DashBoard", true);
            }
            else if (SrViewModel.Administration.ResponseMoveArray() == undefined && appsecurity.SocializationReadOnly() == true) {
                router.navigate("RaSocialization/Administration", true);
            }
            SrViewModel.BreadCrumbArray([]);
        }
        function attached() {
            $("#divNavSwitch2").hide();
            SrViewModel.SelectedTaxonomyOption(null);
            SrViewModel.SelectedTaxonomyOptionFlag(false);
            SrViewModel.contentTabVisible(false);
            SrViewModel.ChangesTabClick(false);
            if (SrViewModel.Administration.ResponseMoveArray() != undefined) {
                SrViewModel.expandCollapseColumns([]);

                SrViewModel.expandCollapseColumns.push(new expandCollapseModel({ colType: "Inherent" }));
                SrViewModel.expandCollapseColumns.push(new expandCollapseModel({ colType: "Controls" }));
                SrViewModel.expandCollapseColumns.push(new expandCollapseModel({ colType: "Residual" }));
                GetAllSurveyType();
                GetUser();
                SrViewModel.tabType('HEATMAP_TYPE2');
                GetTaxonomyList();
            }
            else if (SrViewModel.SurveyDashBoard.ResponseMoveArray() == undefined && appsecurity.SocializationReadOnly() == false) {
                router.navigate("#RaSocialization/DashBoard", true);
            }
            else if (SrViewModel.Administration.ResponseMoveArray() == undefined && appsecurity.SocializationReadOnly() == true) {
                router.navigate("#RaSocialization/Administration", true);
            }
            // Clear Old Values
            SrViewModel.heatMapView(false);
            SrViewModel.heatMapViewNA(false);
        }
        function GetAllSurveyType() {
            return $.ajax({
                url: "/api/Survey/GetSurveyTabsSocialization?DE_RAT_UID=" + SrViewModel.BusinessUnitId(),
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            }).success(function (jsonResult, status) {
                if (jsonResult != null) {
                    SrViewModel.SurveyTypesList(jsonResult);
                    SrViewModel.RootTabList(SrViewModel.SurveyTypesList()[-999]);
                    $('#adddivtabdiv').tabs();
                    $('#adddivtabdiv').tabs('refresh');
                    $('#adddivtabdiv').tabs({ active: 0 });
                    $($('#adddivtabdiv li').get(0)).trigger('click');
                }
            }).fail(function (error, status) {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllSurveyType() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            });
        }
        function createTab(tabId, level, tableUID, tabType, tabName) {
            try {
                SrViewModel.ClickedSurveyType(0)
                SrViewModel.tabType(tabType);

                SrViewModel.tabTypeDetails([]);
                for (var i = 0; i < SrViewModel.SurveyTypesList()[1].length; i++) {
                    if (SrViewModel.SurveyTypesList()[1][i].TabId === tabId) {
                        SrViewModel.tabTypeDetails(SrViewModel.SurveyTypesList()[1][i]);
                        break;
                    }
                }

                if (level == 1) {
                    SrViewModel.AssessmentTypeId(tableUID);
                }
                var childTabList = SrViewModel.SurveyTypesList()[tabId];
                if (childTabList && childTabList.length > 0 && level < 2) {

                    var href = 'Level' + (level + 1);
                    var tabTemplate = `<div class="scroller scroller-left btn-info"><i class="fa fa-chevron-left"></i></div>
                 <div class="scroller scroller-right btn-info"><i class="fa fa-chevron-right "></i></div>
                    <div class="tabswrapper">
                      <ul class="tabs scrolltabs">`;
                    for (var j = 0; j < childTabList.length; j++) {
                        tabTemplate += `<li  data-bind="click: function() {$root.createTab(` + childTabList[j].TabId + `,` + (childTabList[j].Level + 1) + `,` + childTabList[j].TableUID + `,'` + childTabList[j].TabType + `')}">
                                <a class="long-tabs" href="#`+ href + `" data-bind="text: '` + childTabList[j].TabName + `'"></a>
                            </li>`;
                    }
                    tabTemplate += `</ul></div > <div id="` + href + `"></div> `;
                    ko.cleanNode(document.getElementById('Level' + level));
                    document.getElementById('Level' + level).innerHTML = tabTemplate;
                    ko.applyBindings(SrViewModel, document.getElementById('Level' + level));
                    $('#Level' + level).tabs();
                    $('#Level' + level).tabs({ active: 0 });
                    $('#Level' + level).tabs('refresh');
                    $($('#Level' + level + ' li').get(0)).trigger('click');

                } else {
                    SrViewModel.contentTabVisible(false);
                    document.getElementById('Level' + level).innerHTML = "";
                    scrollableTabs();
                    if (tabType && (tabType.indexOf('HEATMAP') >= 0)) {
                        GetAllHeatmapData();
                        $("#heatMapType2Socialization").show();
                    }
                    else if (tabType && (tabType.indexOf('REQUESTS') >= 0)) {
                        $("#heatMapType2Socialization").hide();
                        SrViewModel.TaxonomyLevelListFlag(true);
                        $("#TaxonomyLevelsId").val("")
                        GetOverridesData();
                    }
                    else if (tabType && (tabType.indexOf('SURVEY GROUP') >= 0)) {
                        SrViewModel.TaxonomyLevelListFlag(true);
                        $("#divNavSwitch2").hide();
                        $('#searchFeature').val('');
                        $("#heatMapType2Socialization").hide();
                        SrViewModel.contentTabVisible(true);
                        SrViewModel.ClickedSurveyType(-99999)
                        var tabName = SrViewModel.tabTypeDetails().TabName;
                        if (tabName.toLocaleLowerCase().indexOf("internal") != -1 || tabName.toLocaleLowerCase().indexOf("external") != -1 || tabName.toLocaleLowerCase().indexOf("qualitative") != -1) {
                            SrViewModel.ClickedQualType('');
                            if (tabName.toLocaleLowerCase().indexOf("internal") != -1) {
                                SrViewModel.ClickedQualType("Internal");
                            }
                            else if (tabName.toLocaleLowerCase().indexOf("external") != -1) {
                                SrViewModel.ClickedQualType("External");
                            } else if (tabName.toLocaleLowerCase().indexOf("qualitative") != -1) {
                                SrViewModel.ClickedQualType("Qualitative");
                            }

                            SrViewModel.ClickedSurveyTypeText('qldr');
                            GetColumnDetails('qldr');
                            SrViewModel.Zat_id_Tree(tableUID);
                            SrViewModel.Zat_id_Tree(tableUID);
                            InitiateLevelTree();

                        } else if (tabName.toLocaleLowerCase().indexOf("controls") != -1) {
                            SrViewModel.ClickedSurveyTypeText('cdr');
                            GetColumnDetails('cdr');
                            SrViewModel.Zat_id_Tree(tableUID);
                            InitiateLevelTree();
                        }
                        $('#NavigationToggle1').prop("checked", true);
                    }

                    else if (tabType && (tabType.indexOf('EXECUTIVE_SUMMARY') >= 0)) {
                        SrViewModel.TaxonomyLevelListFlag(true);
                        $("#heatMapType2Socialization").hide();
                        GetAllExecutiveSummary();
                    } else if (tabType && (tabType.indexOf('OFI_TAB') >= 0)) {
                        SrViewModel.TaxonomyLevelListFlag(true);
                        $("#heatMapType2Socialization").hide();
                        GetAllControlNarratives();
                    } else if (tabType && (tabType.indexOf('RISK_DRIVERS') >= 0)) {
                        SrViewModel.TaxonomyLevelListFlag(true);
                        $("#heatMapType2Socialization").hide();
                        SrViewModel.ClickedSurveyTypeText('cdr');
                        GetAllInherentNarratives()
                    }

                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForInherentNarrative() method in Activity.js';
                logger.logMessage(msg);
            }
        }
        function GetAllInherentNarratives(data, event) {
            $('#loadingImgMain').show();
            return $.ajax({
                url: "/api/Configuration/GetAllInherentNarratives",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { DeRatUid: SrViewModel.BusinessUnitId() }
            })
                .success(function (jsonResult, Success) {
                    $('#loadingImg').hide();

                    SrViewModel.InherentNarratives([]);
                    if (jsonResult != null && jsonResult.length > 0) {
                        SrViewModel.InherentNarratives(jsonResult);
                    }
                    BindDynamicHtmlForInherentNarrative();

                    SrViewModel.contentTabVisible(true);
                })
                .fail(function (fail, error) {
                    $('#loadingImgMain').hide();
                });
        }

        function BindDynamicHtmlForInherentNarrative() {
            try {
                var ControlsNarrative = "";
                ControlsNarrative += '<div class="mainQualResponses col-md-12" style="border: 2px solid #0076A8;display: inline-block;padding: 0.5rem;">'

                for (var i = 0; i < SrViewModel.InherentNarratives().length; i++) {
                    ControlsNarrative += '<div class="col-md-12" style="">'
                    ControlsNarrative += '<label class="col-md-12" id="NarTheme" style="font-size: 16px;">' + SrViewModel.InherentNarratives()[i][0][0].Theme + '</label>'
                    for (var j = 0; j < SrViewModel.InherentNarratives()[i].length; j++) {
                        ControlsNarrative += '<label class="col-md-12" id="NarCategory" style="font-size: 13px;font-weight: 600;margin-left:2rem;">' + SrViewModel.InherentNarratives()[i][j][0].Category + '</label>'
                        for (var k = 0; k < SrViewModel.InherentNarratives()[i][j].length; k++) {
                            ControlsNarrative += '<div style="margin-left:4rem;margin-bottom: 1.5rem;">'
                            for (var b = 0; b < SrViewModel.InherentNarratives()[i][j][k].DirectivesList.length; b++) {
                                if (SrViewModel.InherentNarratives()[i][j][k].DirectivesList[b].RemediationId != 0) {
                                    ControlsNarrative += '<div class="col-lg-10">'
                                    ControlsNarrative += '<label class="cc-checkbox">'
                                    ControlsNarrative += '<input id="ChkBox_' + SrViewModel.InherentNarratives()[i][0][0].ThemeId + '_' + SrViewModel.InherentNarratives()[i][j][0].CategoryId + '_' + SrViewModel.InherentNarratives()[i][j][k].DirectivesList[b].RemediationId + '" type="checkbox" data-bind="event: {change : $root.CheckInherentQuestion}, checked: ' + SrViewModel.InherentNarratives()[i][j][k].DirectivesList[b].RemediationFlagCheck + '" />'
                                    ControlsNarrative += '<span class="cc-facet-result-text tag-text">' + SrViewModel.InherentNarratives()[i][j][k].DirectivesList[b].RemediationText + '</span>'
                                    ControlsNarrative += '</label>'
                                    ControlsNarrative += '</div>'
                                }
                            }
                            if (SrViewModel.InherentNarratives()[i][j][k].DirectivesList.length > 0) {
                                ControlsNarrative += '<textarea rows=4 style="margin-left: 2.4rem;width: 80%;"  id="RemTex_' + SrViewModel.InherentNarratives()[i][0][0].ThemeId + '_' + SrViewModel.InherentNarratives()[i][j][0].CategoryId + '"  class="form-control" placeholder=""  type="text" autofocus ></textarea>';
                                $("#RemTex_" + SrViewModel.InherentNarratives()[i][0][0].ThemeId + '_' + SrViewModel.InherentNarratives()[i][j][0].CategoryId).val(SrViewModel.InherentNarratives()[i][j][k].DirectivesList[0].RemediationText);
                            }
                            ControlsNarrative += '</div>'
                        }
                    }
                    ControlsNarrative += '</div>'
                }
                ControlsNarrative += '</div>'

                document.getElementById("NarrativeInherentHtml").innerHTML = "";
                document.getElementById("NarrativeInherentHtml").innerHTML = ControlsNarrative;
                var element = $('#NarrativeInherentHtml')[0];
                ko.cleanNode(element);
                ko.applyBindings(SrViewModel, document.getElementById('NarrativeInherentHtml'));

                getInherentCommentTextBox();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForInherentNarrative() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        function getInherentCommentTextBox() {
            try {
                for (var i = 0; i < SrViewModel.InherentNarratives().length; i++) {
                    for (var j = 0; j < SrViewModel.InherentNarratives()[i].length; j++) {
                        for (var k = 0; k < SrViewModel.InherentNarratives()[i][j].length; k++) {
                            for (var c = 0; c < SrViewModel.InherentNarratives()[i][j][k].DirectivesList.length; c++) {
                                $("#RemTex_" + SrViewModel.InherentNarratives()[i][0][0].ThemeId + '_' + SrViewModel.InherentNarratives()[i][j][0].CategoryId).val(SrViewModel.InherentNarratives()[i][j][k].DirectivesList[0].RemediationText);
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: getInherentCommentTextBox() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        function CheckInherentQuestion(data, event) {
            try {
                var self = this;
                var chkBoxItem = "";
                splitColumnIds = "";
                ThemeId = "",
                    CategoryId = "",
                    RemediationId = "";
                if (event != undefined) {
                    chkBoxItem = event.currentTarget.id;
                }
                if (chkBoxItem != undefined && chkBoxItem != "") {
                    splitColumnIds = chkBoxItem.split("_");
                }

                if (splitColumnIds != undefined && splitColumnIds.length > 1) {
                    ThemeId = splitColumnIds[1];
                    CategoryId = splitColumnIds[2];
                    RemediationId = splitColumnIds[3];
                }
                var remediationPipe = "";
                if (SrViewModel != undefined && SrViewModel.InherentNarratives() != null && SrViewModel.InherentNarratives().length > 0) {

                    for (var i = 0; i < SrViewModel.InherentNarratives().length; i++) {
                        if (SrViewModel.InherentNarratives()[i][0][0].ThemeId == ThemeId) {

                            for (var j = 0; j < SrViewModel.InherentNarratives()[i].length; j++) {
                                if (SrViewModel.InherentNarratives()[i][j][0].CategoryId == CategoryId) {
                                    for (var k = 0; k < SrViewModel.InherentNarratives()[i][j].length; k++) {
                                        for (var b = 0; b < SrViewModel.InherentNarratives()[i][j][k].DirectivesList.length; b++) {

                                            if (SrViewModel.InherentNarratives()[i][j][k].DirectivesList[b].RemediationId == RemediationId) {
                                                if (SrViewModel.InherentNarratives()[i][j][k].DirectivesList[b].RemediationFlagCheck == true) {
                                                    SrViewModel.InherentNarratives()[i][j][k].DirectivesList[b].RemediationFlagCheck = false;
                                                }
                                                else {
                                                    SrViewModel.InherentNarratives()[i][j][k].DirectivesList[b].RemediationFlagCheck = true;
                                                }
                                            }

                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CheckInherentQuestion() method in Activity.js';
                logger.logMessage(msg);
            }
        }
        function setInherentNarOptions() {
            try {
                if (SrViewModel != undefined && SrViewModel.InherentNarratives() != null && SrViewModel.InherentNarratives().length > 0) {
                    for (var i = 0; i < SrViewModel.InherentNarratives().length; i++) {
                        for (var j = 0; j < SrViewModel.InherentNarratives()[i].length; j++) {
                            for (var k = 0; k < SrViewModel.InherentNarratives()[i][j].length; k++) {
                                for (var c = 0; c < SrViewModel.InherentNarratives()[i][j][k].DirectivesList.length; c++) {
                                    var remediationPipe = "";
                                    for (var d = 1; d < SrViewModel.InherentNarratives()[i][j][k].DirectivesList.length; d++) {
                                        //set pipe delimeter selected options
                                        if (SrViewModel.InherentNarratives()[i][j][k].DirectivesList[d].RemediationFlagCheck == true) {
                                            if (remediationPipe == "")
                                                remediationPipe = SrViewModel.InherentNarratives()[i][j][k].DirectivesList[d].RemediationText;
                                            else {
                                                remediationPipe += '|' + SrViewModel.InherentNarratives()[i][j][k].DirectivesList[d].RemediationText;
                                            }
                                        }
                                    }
                                    SrViewModel.InherentNarratives()[i][j][k].DirectivesList[c].RemediationTextSave = remediationPipe;
                                    SrViewModel.InherentNarratives()[i][j][k].DirectivesList[c].Comment = $("#RemTex_" + SrViewModel.InherentNarratives()[i][0][0].ThemeId + '_' + SrViewModel.InherentNarratives()[i][j][0].CategoryId).val();
                                    break;
                                }
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: setInherentCommentTextBox() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        function SubmitInherentNarratives() {
            try {
                $('#loadingImgMain').show();
                setInherentNarOptions();
                var JsonList = SrViewModel.InherentNarratives();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Configuration/SaveInherentNarrativesData",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(JsonList)
                })
                    .success(function (jsonResult, success) {
                        $('#loadingImgMain').hide();
                        if (jsonResult == null) {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);

                        }
                        else if (jsonResult == 0) {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);

                        }
                        else {
                            GetAllInherentNarratives();
                            logger.logSuccess('Responses have been saved successfully.', 'Success', system.getModuleId(SrViewModel), true)
                        }
                    })
                    .fail(function (fail, error) {
                        $('#loadingImgMain').hide();
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubmitInherentNarratives() method in SurveyResponse.js';
                logger.logMessage(msg);
                $('#loadingImgMain').hide();
            }
        }

        function ResetInhNarratives() {
            try {
                GetAllInherentNarratives();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetInhNarratives() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        function CheckControlQuestion(data, event) {
            try {
                var self = this;
                var chkBoxItem = "";
                splitColumnIds = "";
                ThemeId = "",
                    CategoryId = "",
                    QuestionId = "",
                    RemediationId = "";
                if (event != undefined) {
                    chkBoxItem = event.currentTarget.id;
                }
                if (chkBoxItem != undefined && chkBoxItem != "") {
                    splitColumnIds = chkBoxItem.split("_");
                }

                if (splitColumnIds != undefined && splitColumnIds.length > 1) {
                    ThemeId = splitColumnIds[1];
                    CategoryId = splitColumnIds[2];
                    QuestionId = splitColumnIds[3];
                    RemediationId = splitColumnIds[4];
                }
                var remediationPipe = "";
                if (SrViewModel != undefined && SrViewModel.ControlNarratives() != null && SrViewModel.ControlNarratives().length > 0) {

                    for (var i = 0; i < SrViewModel.ControlNarratives().length; i++) {
                        if (SrViewModel.ControlNarratives()[i][0][0].ThemeId == ThemeId) {

                            for (var j = 0; j < SrViewModel.ControlNarratives()[i].length; j++) {
                                if (SrViewModel.ControlNarratives()[i][j][0].CategoryId == CategoryId) {
                                    for (var k = 0; k < SrViewModel.ControlNarratives()[i][j].length; k++) {
                                        if (SrViewModel.ControlNarratives()[i][j][k].QuestionId == QuestionId) {
                                            for (var b = 0; b < SrViewModel.ControlNarratives()[i][j][k].DirectivesList.length; b++) {

                                                //Set flag
                                                if (SrViewModel.ControlNarratives()[i][j][k].DirectivesList[b].RemediationId == RemediationId) {
                                                    if (SrViewModel.ControlNarratives()[i][j][k].DirectivesList[b].RemediationFlagCheck == true) {
                                                        SrViewModel.ControlNarratives()[i][j][k].DirectivesList[b].RemediationFlagCheck = false;
                                                    }
                                                    else {
                                                        SrViewModel.ControlNarratives()[i][j][k].DirectivesList[b].RemediationFlagCheck = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CheckControlQuestion() method in Activity.js';
                logger.logMessage(msg);
            }
        }



        function ExportExecutiveSummary() {
            try {
                $('#SummaryReportPopUp').modal('show');
                $('#divSummaryReport').html('');
                var homeurl = homeUrlLocation;
                var url = window.location.hash;
                $('<iframe>', {
                    src: homeurl + 'SSRSExecutiveSummary.aspx?DeRatUid=' + SrViewModel.BusinessUnitId(),
                    id: 'iframe_FINDINGS',
                    frameborder: 0,
                    style: 'display: block; width: 100%; height: 36rem; margin-left: 0px;',
                }).appendTo('#divSummaryReport');

                $('#loadingImgMainRC2').hide();
                $('#divSummaryReport').show();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ExportExecutiveSummary() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function SubmitExecutiveSummary(data, event) {
            try {
                var inherentText = $('#InhRiskDriversTextId').parent().parent().children().closest('[class^="jqte_editor"]').html();
                var controlsText = $('#CntrlRiskDriversTextId').parent().parent().children().closest('[class^="jqte_editor"]').html();
                var otherExeText = $('#OtherRiskDriversTextId').parent().parent().children().closest('[class^="jqte_editor"]').html();

                if (inherentText.length <= 0) {
                    document.getElementById('lblErrorInht').innerHTML = "The Inherent risk summary is mandatory, please fill the details";
                    $('#lblErrorInht').show();
                }
                else if (inherentText.length > 4000) {
                    document.getElementById('lblErrorInht').innerHTML = "The Inherent risk summary should not exceed 4000 characters.";
                    $('#lblErrorInht').show();
                }
                else {
                    document.getElementById('lblErrorInht').innerHTML = "";
                    $('#lblErrorInht').hide();
                }

                if (controlsText.length <= 0) {
                    document.getElementById('lblErrorCntrl').innerHTML = "The External environment summary is mandatory, please fill the details";
                    $('#lblErrorCntrl').show();
                }
                else if (controlsText.length > 4000) {
                    document.getElementById('lblErrorCntrl').innerHTML = "The External environment summary should not exceed 4000 characters.";
                    $('#lblErrorCntrl').show();
                }
                else {
                    document.getElementById('lblErrorCntrl').innerHTML = "";
                    $('#lblErrorCntrl').hide();
                }

                if (otherExeText.length > 4000) {
                    document.getElementById('lblErrorOther').innerHTML = "The Key takeaways summary should not exceed 4000 characters.";
                    $('#lblErrorOther').show();
                } else {
                    document.getElementById('lblErrorOther').innerHTML = "";
                    $('#lblErrorOther').hide();
                }
                if (inherentText.length > 4000 || controlsText.length > 4000 || otherExeText.length > 4000 || inherentText.length <= 0 || controlsText.length <= 0) {
                    return false;
                }

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Configuration/SaveExecutiveSummaryDetails",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: JSON.stringify({
                        InhRiskDriversText: inherentText,
                        CntrlRiskDriversText: controlsText,
                        OtherRiskDriversText: otherExeText,
                        DeRatUId: SrViewModel.BusinessUnitId(),
                        SSId: SrViewModel.executiveSummaryDetails().SSId
                    })
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult != null && jsonResult > 0) {
                            logger.logSuccess('Summary is saved successfully.', 'Success', system.getModuleId(SrViewModel), true);
                        } else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                    })
                    .fail(function (fail, error) {
                        $('#loadingImgMain').hide();
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubmitExecutiveSummary() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function ResetExecutiveSummary() {
            try {
                GetAllExecutiveSummary();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetExecutiveSummary() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        function GetAllExecutiveSummary() {
            SrViewModel.contentTabVisible(false);
            return $.ajax({
                url: "/api/Configuration/GetExecutiveSummaryDetails",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: {
                    DeRatUid: SrViewModel.BusinessUnitId()
                }
            }).success(function (jsonResult, Success) {

                if (jsonResult != null && jsonResult != undefined) {
                    SrViewModel.executiveSummaryDetails(jsonResult);
                    SrViewModel.contentTabVisible(true);

                    SrViewModel.SSId(0);
                    SrViewModel.FileExtension('.pdf');
                    SrViewModel.InhRiskDriversText('');
                    SrViewModel.CntrlRiskDriversText('');
                    SrViewModel.OtherRiskDriversText('');
                    SrViewModel.KeyMethodologyText('');
                    SrViewModel.SSId(jsonResult.SSId);
                    SrViewModel.InhRiskDriversText(jsonResult.InhRiskDriversText);
                    SrViewModel.CntrlRiskDriversText(jsonResult.CntrlRiskDriversText);
                    SrViewModel.OtherRiskDriversText(jsonResult.OtherRiskDriversText);
                    SrViewModel.KeyMethodologyText(jsonResult.KeyMethodologyText);
                    SrViewModel.WarningInfoLebel(jsonResult.WarningInfoLebel);
                    SrViewModel.FileExtension(jsonResult.FileExtension);
                    BindHtmlForExecutiveSummary();
                }
            }).fail(function (fail, error) {

            });
        }

        function BindHtmlForExecutiveSummary() {
            try {
                var ExecutiveSum = "";

                ExecutiveSum += '<div id="NarrativeExecSummary" class="col-md-12" style="">'
                ExecutiveSum += '<div style="display: inline-block;"class="col-lg-12" id="InhRiskDriversSection" style="margin-bottom:-1rem;">'
                ExecutiveSum += '<div style="">'
                ExecutiveSum += '<span style="color:red;font-weight:bold;padding-right: 0.3rem;font-size: 14px;">*</span>'
                ExecutiveSum += '<label id="NarInhExecSummary" style="font-size: 15px;">Key Inherent Risk Drivers:</label>&nbsp;&nbsp;<span>[Refer to Critical / High Internal Inherent Risk Drivers Tab]</span>'
                ExecutiveSum += '</div>'
                ExecutiveSum += '<div class="col-lg-8" style="margin-top: -2rem;">'
                ExecutiveSum += '<textarea id="InhRiskDriversTextId" class="jqte-test" data-bind="value: $root.InhRiskDriversText"></textarea>'
                ExecutiveSum += '</div>'
                ExecutiveSum += '</div>'

                ExecutiveSum += '<div class="col-lg-12" id="CntrlRiskDriversSection" style="display: inline-block;">'
                ExecutiveSum += '<div style="">'
                ExecutiveSum += '<span style="color:red;font-weight:bold;padding-right: 0.3rem;font-size: 14px;">*</span>'
                ExecutiveSum += '<label class="" id="NarCntrlExecSummary" style="font-size: 15px;">Key External Environment Drivers:</label>&nbsp;&nbsp;<span>[Regulatory Complexity and Regulatory Focus]</span>'
                ExecutiveSum += '</div>'
                ExecutiveSum += '<div class="col-lg-8" style="margin-top: -2rem;">'
                ExecutiveSum += '<textarea id="CntrlRiskDriversTextId" class="jqte-test" data-bind="value: $root.CntrlRiskDriversText"></textarea>'
                ExecutiveSum += '</div>'
                ExecutiveSum += '</div>'

                ExecutiveSum += '<div class="col-lg-12" id="OtherRiskDriversSection" style="display: inline-block;">'
                ExecutiveSum += '<div style="">'
                ExecutiveSum += '<label class="" id="NarOtherExecSummary" style="font-size: 15px;">Other Key Takeaways : </label>'
                ExecutiveSum += '</div>'
                ExecutiveSum += '<div class="col-lg-8" style="margin-top: -2rem;">'
                ExecutiveSum += '<textarea id="OtherRiskDriversTextId" class="jqte-test" data-bind="value: $root.OtherRiskDriversText"></textarea>'
                ExecutiveSum += '</div>'
                ExecutiveSum += '</div>'

                 ExecutiveSum += '</div>';

                $('#NarrativeExecSummaryHtml').html("");
                $('#NarrativeExecSummaryHtml').html(ExecutiveSum);
                var element = $('#NarrativeExecSummaryHtml')[0];
                ko.cleanNode(element);
                ko.applyBindings(SrViewModel, document.getElementById('NarrativeExecSummaryHtml'));
                $("#InhRiskDriversTextId").jqte();
                $("#CntrlRiskDriversTextId").jqte();
                $("#OtherRiskDriversTextId").jqte();

                $('#lblErrorInht').hide();
                $('#lblErrorCntrl').hide();
                $('#lblErrorOther').hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BindHtmlForExecutiveSummary() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        //-----------Socialization control narratives code--------------------//
        function GetAllControlNarratives(data, event) {
            SrViewModel.contentTabVisible(false);
            return $.ajax({
                url: "/api/Configuration/GetAllControlNarratives",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { DeRatUId: SrViewModel.BusinessUnitId() }
            })
                .success(function (jsonResult, Success) {


                    SrViewModel.ControlNarratives([]);
                    if (jsonResult != null && jsonResult.length > 0) {
                        SrViewModel.ControlNarratives(jsonResult);
                    }
                    BindDynamicHtmlForControlsNarrative();
                    SrViewModel.contentTabVisible(true);

                })
                .fail(function (fail, error) {
                    $('#loadingImgMain').hide();
                });
        }


        //Bind Dynamic Html
        function BindDynamicHtmlForControlsNarrative() {
            try {
                var ControlsNarrative = "";
                ControlsNarrative += '<div class="mainQualResponses col-md-12" style="border: 2px solid #0076A8;display: inline-block;padding: 0.5rem;">'

                for (var i = 0; i < SrViewModel.ControlNarratives().length; i++) {
                    ControlsNarrative += '<div class="col-md-12" style="">'
                    ControlsNarrative += '<label class="col-md-12" id="NarTheme" style="font-size: 16px;">' + SrViewModel.ControlNarratives()[i][0][0].Theme + '</label>'
                    for (var j = 0; j < SrViewModel.ControlNarratives()[i].length; j++) {
                        ControlsNarrative += '<label class="col-md-12" id="NarCategory" style="font-size: 14px;margin-left:2rem;">' + SrViewModel.ControlNarratives()[i][j][0].Category + '</label>'
                        for (var k = 0; k < SrViewModel.ControlNarratives()[i][j].length; k++) {
                            ControlsNarrative += '<label class="col-md-12" id="NarQuestionText" style="margin-left:3rem;font-weight: 600;">' + SrViewModel.ControlNarratives()[i][j][k].QuestionText + '</label>'
                            ControlsNarrative += '<div style="margin-left:4rem;margin-bottom: 1.5rem;">'
                            for (var b = 0; b < SrViewModel.ControlNarratives()[i][j][k].DirectivesList.length; b++) {
                                if (SrViewModel.ControlNarratives()[i][j][k].DirectivesList[b].RemediationId != 0) {
                                    ControlsNarrative += '<div class="col-lg-10">'
                                    ControlsNarrative += '<label class="cc-checkbox">'
                                    ControlsNarrative += '<input id="ChkBox_' + SrViewModel.ControlNarratives()[i][0][0].ThemeId + '_' + SrViewModel.ControlNarratives()[i][j][0].CategoryId + '_' + SrViewModel.ControlNarratives()[i][j][k].QuestionId + '_' + SrViewModel.ControlNarratives()[i][j][k].DirectivesList[b].RemediationId + '" type="checkbox" data-bind="event: {change : $root.CheckControlQuestion}, checked: ' + SrViewModel.ControlNarratives()[i][j][k].DirectivesList[b].RemediationFlagCheck + '" />'
                                    ControlsNarrative += '<span class="cc-facet-result-text tag-text">' + SrViewModel.ControlNarratives()[i][j][k].DirectivesList[b].RemediationText + '</span>'
                                    ControlsNarrative += '</label>'
                                    ControlsNarrative += '</div>'
                                }
                            }
                            if (SrViewModel.ControlNarratives()[i][j][k].DirectivesList.length > 0) {
                                ControlsNarrative += '<textarea rows=4 style="margin-left: 2.4rem;width: 80%;" id="RemTex_' + SrViewModel.ControlNarratives()[i][0][0].ThemeId + '_' + SrViewModel.ControlNarratives()[i][j][0].CategoryId + '_' + SrViewModel.ControlNarratives()[i][j][k].QuestionId + '"  class="form-control" placeholder=""  type="text" autofocus ></textarea>';
                                $("#RemTex_" + SrViewModel.ControlNarratives()[i][0][0].ThemeId + '_' + SrViewModel.ControlNarratives()[i][j][0].CategoryId + '_' + SrViewModel.ControlNarratives()[i][j][k].QuestionId).val(SrViewModel.ControlNarratives()[i][j][k].DirectivesList[0].RemediationText);
                            }
                            ControlsNarrative += '</div>'
                        }
                    }
                    ControlsNarrative += '</div>'
                }
                ControlsNarrative += '</div>'

                document.getElementById("NarrativeControlHtml").innerHTML = "";
                document.getElementById("NarrativeControlHtml").innerHTML = ControlsNarrative;
                var element = $('#NarrativeControlHtml')[0];
                ko.cleanNode(element);
                ko.applyBindings(SrViewModel, document.getElementById('NarrativeControlHtml'));

                getCommentTextBox();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForControlsNarrative() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function getCommentTextBox() {
            try {
                for (var i = 0; i < SrViewModel.ControlNarratives().length; i++) {
                    for (var j = 0; j < SrViewModel.ControlNarratives()[i].length; j++) {
                        for (var k = 0; k < SrViewModel.ControlNarratives()[i][j].length; k++) {
                            for (var c = 0; c < SrViewModel.ControlNarratives()[i][j][k].DirectivesList.length; c++) {
                                $("#RemTex_" + SrViewModel.ControlNarratives()[i][0][0].ThemeId + '_' + SrViewModel.ControlNarratives()[i][j][0].CategoryId + '_' + SrViewModel.ControlNarratives()[i][j][k].QuestionId).val(SrViewModel.ControlNarratives()[i][j][k].DirectivesList[0].RemediationText);
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: setCommentTextBox() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function setControlNarOptions() {
            try {
                if (SrViewModel != undefined && SrViewModel.ControlNarratives() != null && SrViewModel.ControlNarratives().length > 0) {
                    for (var i = 0; i < SrViewModel.ControlNarratives().length; i++) {
                        for (var j = 0; j < SrViewModel.ControlNarratives()[i].length; j++) {
                            for (var k = 0; k < SrViewModel.ControlNarratives()[i][j].length; k++) {
                                for (var c = 0; c < SrViewModel.ControlNarratives()[i][j][k].DirectivesList.length; c++) {
                                    var remediationPipe = "";
                                    for (var d = 1; d < SrViewModel.ControlNarratives()[i][j][k].DirectivesList.length; d++) {
                                        //set pipe delimeter selected options
                                        if (SrViewModel.ControlNarratives()[i][j][k].DirectivesList[d].RemediationFlagCheck == true) {
                                            if (remediationPipe == "")
                                                remediationPipe = SrViewModel.ControlNarratives()[i][j][k].DirectivesList[d].RemediationText;
                                            else {
                                                remediationPipe += '|' + SrViewModel.ControlNarratives()[i][j][k].DirectivesList[d].RemediationText;
                                            }
                                        }
                                    }
                                    SrViewModel.ControlNarratives()[i][j][k].DirectivesList[c].RemediationTextSave = remediationPipe;
                                    SrViewModel.ControlNarratives()[i][j][k].DirectivesList[c].Comment = $("#RemTex_" + SrViewModel.ControlNarratives()[i][0][0].ThemeId + '_' + SrViewModel.ControlNarratives()[i][j][0].CategoryId + '_' + SrViewModel.ControlNarratives()[i][j][k].QuestionId).val();
                                    break;
                                }
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: setControlNarOptions() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function SubmitNarratives() {
            try {
                $('#loadingImgMain').show();
                setControlNarOptions();
                var JsonList = SrViewModel.ControlNarratives();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Configuration/SaveControlNarrativesData",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(JsonList)
                })
                    .success(function (jsonResult, success) {
                        $('#loadingImgMain').hide();
                        if (jsonResult == null) {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);

                        }
                        else if (jsonResult == 0) {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);

                        }
                        else {
                            GetAllControlNarratives();
                            logger.logSuccess('Responses have been saved successfully.', 'Success', system.getModuleId(SrViewModel), true)
                        }
                    })
                    .fail(function (fail, error) {
                        $('#loadingImgMain').hide();
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubmitNarratives() method in SurveyResponse.js';
                logger.logMessage(msg);
                $('#loadingImgMain').hide();
            }
        }

        function ResetContrlNarratives() {
            try {
                GetAllControlNarratives();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetContrlNarratives() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function GetOverridesData() {
            return $.ajax({
                url: "/api/HeatMap/GetOverrideRequests?deRatUid=" + SrViewModel.BusinessUnitId(),
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            }).success(function (jsonResult, success) {
                if (jsonResult != null) {
                    if ($.fn.dataTable.isDataTable('#tblOverrideRequests')) {
                        $('#tblOverrideRequests').DataTable().destroy();
                        $('#tblOverrideRequests tbody tr').remove();
                    }
                    if ($.fn.dataTable.isDataTable('#tblOverrideRequestsRecal')) {
                        $('#tblOverrideRequestsRecal').DataTable().destroy();
                        $('#tblOverrideRequestsRecal tbody tr').remove();
                    }
                    if (jsonResult.overrideReqModel) {
                        mappedReqData = $.map(jsonResult.overrideReqModel, function (result) {
                            return new requestModel(result);
                        });
                        SrViewModel.overrideRequestList(mappedReqData);
                    }

                    if (jsonResult.overrideReqModelReCal) {
                        mappedReqRCData = $.map(jsonResult.overrideReqModelReCal, function (result) {
                            return new requestModel(result);
                        });
                        SrViewModel.overrideRequestListRecal(mappedReqRCData);
                    }

                    if (jsonResult.overrideActionModel) {
                        SrViewModel.overrideActionList(jsonResult.overrideActionModel);
                    }
                    SrViewModel.contentTabVisible(true);
                    overrideDataTableReInitialize();
                }
            });
        }


        function GetAllHeatmapData() {
            try {
                if (SrViewModel.AssessmentTypeId()) {
                    var DynamicUrl = '';

                    if (SrViewModel.SelectedTaxonomyOption() == undefined) {
                        DynamicUrl = "/api/HeatMap/GetHeatMapDataSocialization?DERAT_UID=" + SrViewModel.BusinessUnitId() + '&Assessment_ID=' + SrViewModel.AssessmentTypeId() + '&Level_ID=' + '';
                    } else {
                        DynamicUrl = "/api/HeatMap/GetHeatMapDataSocialization?DERAT_UID=" + SrViewModel.BusinessUnitId() + '&Assessment_ID=' + SrViewModel.AssessmentTypeId() + '&Level_ID=' + SrViewModel.SelectedTaxonomyOption();
                    }
                    return $.ajax({
                        url: DynamicUrl,
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders()
                    }).success(function (jsonResult, success) {
                        if (jsonResult != null) {
                            if ($.fn.dataTable.isDataTable('#tblHeatMapSocialization')) {
                                $('#tblHeatMapSocialization').DataTable().destroy();
                                $('#tblHeatMapSocialization tbody tr').remove();
                            }
                            if ($.fn.dataTable.isDataTable('#tblResHeatMapSocialization')) {
                                $('#tblResHeatMapSocialization').DataTable().destroy();
                                $('#tblResHeatMapSocialization tbody tr').remove();
                            }
                            if ($.fn.dataTable.isDataTable('#tblCntrlHeatMapSocialization')) {
                                $('#tblCntrlHeatMapSocialization').DataTable().destroy();
                                $('#tblCntrlHeatMapSocialization tbody tr').remove();
                            }
                            if ($.fn.dataTable.isDataTable('#tblInhHeatMapSocialization')) {
                                $('#tblInhHeatMapSocialization').DataTable().destroy();
                                $('#tblInhHeatMapSocialization tbody tr').remove();
                            }



                            if (jsonResult.ControlHeatMapDataSocialization) {
                                SrViewModel.cntrlHeatMapDataListDUPRaw(jsonResult.ControlHeatMapDataSocialization); // save for Areas of change refresh

                                mappedInhData = $.map(jsonResult.ControlHeatMapDataSocialization, function (result) {
                                    return new heatMapDataModel(result);
                                });
                                SrViewModel.cntrlHeatMapDataList(mappedInhData);
                                SrViewModel.cntrlHeatMapDataListDUP(mappedInhData);
                                SrViewModel.showCntrlHeatMap(true);
                            } else {
                                SrViewModel.cntrlHeatMapDataList(null);
                                SrViewModel.cntrlHeatMapDataListDUP(null);
                                SrViewModel.cntrlHeatMapDataListDUPRaw(null);
                                SrViewModel.showCntrlHeatMap(false);
                            }
                            if (jsonResult.ResidualHeatMapDataSocialization) {
                                SrViewModel.residualHeatMapDataListDUPRaw(jsonResult.ResidualHeatMapDataSocialization); // save for Areas of change refresh
                                mappedInhData = $.map(jsonResult.ResidualHeatMapDataSocialization, function (result) {
                                    return new heatMapDataModel(result);
                                });
                                SrViewModel.residualHeatMapDataList(mappedInhData);
                                SrViewModel.residualHeatMapDataListDUP(mappedInhData);
                            } else {
                                SrViewModel.residualHeatMapDataList(null);
                                SrViewModel.residualHeatMapDataListDUP(null);
                                SrViewModel.residualHeatMapDataListDUPRaw(null);
                            }
                            if (jsonResult.InherentHeatMapDataSocialization) {
                                SrViewModel.inhHeatMapDataListDUPRaw(jsonResult.InherentHeatMapDataSocialization); // save for Areas of change refresh
                                mappedInhData = $.map(jsonResult.InherentHeatMapDataSocialization, function (result) {
                                    return new heatMapDataModel(result);
                                });
                                SrViewModel.inhHeatMapDataList(mappedInhData);
                                SrViewModel.inhHeatMapDataListDUP(mappedInhData);
                                SrViewModel.showInhHeatMap(true);
                            } else {
                                SrViewModel.inhHeatMapDataList(null);
                                SrViewModel.inhHeatMapDataListDUP(null);
                                SrViewModel.inhHeatMapDataListDUPRaw(null);
                                SrViewModel.showInhHeatMap(false);
                            }
                            if (jsonResult.InherentBuAggHeatMapDataSocialization) {
                                mappedInhData = $.map(jsonResult.InherentBuAggHeatMapDataSocialization, function (result) {
                                    return new heatMapDataModel(result);
                                });
                                SrViewModel.inhHeatMapFinalData(mappedInhData[0]);
                                SrViewModel.inhHeatMapFinalDataDUP(mappedInhData[0]);
                            } else {
                                SrViewModel.inhHeatMapFinalData(null);
                                SrViewModel.inhHeatMapFinalDataDUP(null);
                            }
                            if (jsonResult.ControlBuAggHeatMapDataSocialization) {
                                mappedInhData = $.map(jsonResult.ControlBuAggHeatMapDataSocialization, function (result) {
                                    return new heatMapDataModel(result);
                                });
                                SrViewModel.cntrlHeatMapFinalData(mappedInhData[0]);
                            } else {
                                SrViewModel.cntrlHeatMapFinalData(null);
                            }
                            if (jsonResult.ResiduaBulHeatMapDataSocialization) {
                                mappedInhData = $.map(jsonResult.ResiduaBulHeatMapDataSocialization, function (result) {
                                    return new heatMapDataModel(result);
                                });
                                SrViewModel.residualHeatMapFinalData(mappedInhData[0]);
                                SrViewModel.showResdHeatMap(true);
                            } else {
                                SrViewModel.residualHeatMapFinalData(null);
                                SrViewModel.showResdHeatMap(false);
                            }
                            SrViewModel.inhHeatMapDrpDwn(jsonResult.InhRiskDropDown);
                            SrViewModel.cntrlHeatMapDrpDwn(jsonResult.CntrlRiskDropDown);
                            SrViewModel.resHeatMapDrpDwn(jsonResult.ResidualRiskDropDown);
                            SrViewModel.inhFactorHeatMapDrpDwn(jsonResult.InhFactorDropDown);
                            SrViewModel.contentTabVisible(true);
                            if (jsonResult.OverallRiskDropDown != undefined && jsonResult.OverallRiskDropDown.length > 0) {
                                SrViewModel.OrgLevelFlag(jsonResult.OverallRiskDropDown[0].OrgLevelFlag);
                                if (SrViewModel.OrgLevelFlag()) {
                                    SrViewModel.OrgAUConlspan(5);
                                } else {
                                    SrViewModel.OrgAUConlspan(3);
                                }
                            }

                            heatmapDataTableReInitialize();
                            BindDynamicLevels();
                        }
                    });
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetHeatmapCRA() method in SR.js';
                logger.logMessage(msg);
            }
        }
        function overrideDataTableReInitialize() {
            if ($.fn.dataTable.isDataTable('#tblOverrideRequests')) {
                $('#tblOverrideRequests').dataTable().fnClearTable();
            }
            $('#tblOverrideRequests').DataTable(
                {
                    "autoWidth": true,
                    "bSort": false,
                    scrollY: "380px",
                    scrollX: true,
                    scrollCollapse: true,
                    bFilter: false,
                    paging: false,
                    "bInfo": false,
                    fixedHeader: {
                        header: true
                    }
                });

            if ($.fn.dataTable.isDataTable('#tblOverrideRequestsRecal')) {
                $('#tblOverrideRequestsRecal').dataTable().fnClearTable();
            }
            $('#tblOverrideRequestsRecal').DataTable(
                {
                    "aLengthMenu": [60, 20, 20],
                    "bSort": false,
                    scrollY: "380px",
                    scrollX: true,
                    scrollCollapse: true,
                    bFilter: false,
                    paging: false,
                    "bInfo": false,
                    fixedHeader: {
                        header: true
                    }
                });

        }

        function heatmapDataTableReInitialize() {
            try {
                if (SrViewModel.tabType() == 'HEATMAP_TYPE1') {
                    if ($.fn.dataTable.isDataTable('#tblInhHeatMapSocialization')) {
                        $('#tblInhHeatMapSocialization').DataTable().destroy();
                        $('#tblInhHeatMapSocialization tbody tr').remove();
                    }
                    SrViewModel.inhHeatMapDataList([]);

                    //Areas of change logic
                    if (SrViewModel.SelectedTaxonomyOptionRefresh() != -9999 ) {
                        SrViewModel.inhHeatMapDataList(SrViewModel.inhHeatMapDataListDUP());
                    } else {
                        if (SrViewModel.inhHeatMapDataListDUPRaw() !== null) {
                            mappedInhData = $.map(SrViewModel.inhHeatMapDataListDUPRaw(), function (result) {
                                return new heatMapDataChangeModel(result);
                            });
                            SrViewModel.inhHeatMapDataList(mappedInhData);
                        }
                        else
                            SrViewModel.inhHeatMapDataList(null);
                    }

                    $('#tblInhHeatMapSocialization').DataTable(
                        {
                            "bSort": false,
                            scrollY: "700px",
                            scrollX: true,
                            scrollCollapse: true,
                            bFilter: false,
                            paging: false,
                            "bInfo": false,
                            fixedHeader: {
                                header: true
                            }
                        });
                    // Controls Table
                    if ($.fn.dataTable.isDataTable('#tblCntrlHeatMapSocialization')) {
                        $('#tblCntrlHeatMapSocialization').DataTable().destroy();
                        $('#tblCntrlHeatMapSocialization tbody tr').remove();
                    }
                    SrViewModel.cntrlHeatMapDataList([]);
                    if (SrViewModel.SelectedTaxonomyOptionRefresh() != -9999) {
                        SrViewModel.cntrlHeatMapDataList(SrViewModel.cntrlHeatMapDataListDUP());
                    } else {
                        if (SrViewModel.cntrlHeatMapDataListDUPRaw() !== null) {
                            mappedInhData = $.map(SrViewModel.cntrlHeatMapDataListDUPRaw(), function (result) {
                                return new heatMapDataChangeModel(result);
                            });
                            SrViewModel.cntrlHeatMapDataList(mappedInhData);
                        }
                        else
                            SrViewModel.cntrlHeatMapDataList(null);
                    }

                    $('#tblCntrlHeatMapSocialization').DataTable(
                        {
                            "bSort": false,
                            scrollY: "700px",
                            scrollX: true,
                            scrollCollapse: true,
                            bFilter: false,
                            paging: false,
                            "bInfo": false,
                            fixedHeader: {
                                header: true
                            }
                        });
                    // Residual Table
                    if ($.fn.dataTable.isDataTable('#tblResHeatMapSocialization')) {
                        $('#tblResHeatMapSocialization').DataTable().destroy();
                        $('#tblResHeatMapSocialization tbody tr').remove();
                    }
                    SrViewModel.residualHeatMapDataList([]);
                    //Areas of change logic
                    if (SrViewModel.SelectedTaxonomyOptionRefresh() != -9999) {
                        SrViewModel.residualHeatMapDataList(SrViewModel.residualHeatMapDataListDUP());
                    } else {
                        if (SrViewModel.residualHeatMapDataListDUPRaw() !== null) {
                            mappedInhData = $.map(SrViewModel.residualHeatMapDataListDUPRaw(), function (result) {
                                return new heatMapDataChangeModel(result);
                            });
                            SrViewModel.residualHeatMapDataList(mappedInhData);
                        }
                        else
                            SrViewModel.residualHeatMapDataList(null);
                    }

                    $('#tblResHeatMapSocialization').DataTable(
                        {
                            "bSort": false,
                            scrollY: "700px",
                            scrollX: true,
                            scrollCollapse: true,
                            bFilter: false,
                            paging: false,
                            "bInfo": false,
                            fixedHeader: {
                                header: true
                            }
                        });
                }
                else if (SrViewModel.tabType() == 'HEATMAP_TYPE2') {
                    if (SrViewModel.SelectedTaxonomyOption() != -999) {
                        if ($.fn.dataTable.isDataTable('#tblHeatMapSocialization')) {
                            $('#tblHeatMapSocialization').DataTable().destroy();
                            $('#tblHeatMapSocialization tbody tr').remove();
                        }
                        SrViewModel.inhHeatMapDataList([]);

                        //Areas of change logic
                        if (SrViewModel.SelectedTaxonomyOptionRefresh() != -9999) {
                            SrViewModel.inhHeatMapDataList(SrViewModel.inhHeatMapDataListDUP());
                        } else {
                            mappedInhData = $.map(SrViewModel.inhHeatMapDataListDUPRaw(), function (result) {
                                return new heatMapDataChangeModel(result);
                            });
                            SrViewModel.inhHeatMapDataList(mappedInhData);
                        }

                        $('#tblHeatMapSocialization').DataTable(
                            {
                                retrieve: true,
                                "bSort": false,
                                scrollY: "700px",
                                scrollX: true,
                                scrollCollapse: true,
                                bFilter: false,
                                paging: false,
                                "bInfo": false,
                                fixedHeader: {
                                    header: true
                                }
                            });

                }
                    if (SrViewModel.SelectedTaxonomyOption() == -999) {

                        if ($.fn.dataTable.isDataTable('#tblHeatMapSocializationFinal')) {
                            $('#tblHeatMapSocializationFinal').DataTable().destroy();
                        }

                        SrViewModel.inhHeatMapFinalData(SrViewModel.inhHeatMapFinalDataDUP());
                        $('#tblHeatMapSocializationFinal').DataTable(
                            {
                                retrieve: true,
                                "bSort": false,
                                bFilter: false,
                                paging: false,
                                "bInfo": false,
                            });
                    }
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetUser() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function GetUser() {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Reporting/GetUser",
                    type: "GET",
                    headers: headers,

                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetUser() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {

                    SrViewModel.User(jsonResult);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetUser() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetUser() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetUser() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }


        function expandCollapseAll(type) {
            if (type == 'type1') {
                $('#toggleExpandCollapse').click();
            }
            else {
                if (SrViewModel.expandCollapse() == 'E')
                    SrViewModel.expandCollapse('C');
                else if (SrViewModel.expandCollapse() == 'C')
                    SrViewModel.expandCollapse('E');
                ko.utils.arrayForEach(SrViewModel.inhHeatMapDataList(), function (Param) {
                    if (SrViewModel.expandCollapse() == 'E') {
                        Param.childrenVisible(true);
                    }
                    else {
                        Param.childrenVisible(false);
                    }
                });
                ko.utils.arrayForEach(SrViewModel.cntrlHeatMapDataList(), function (Param) {
                    if (SrViewModel.expandCollapse() == 'E') {
                        Param.childrenVisible(true);
                    }
                    else {
                        Param.childrenVisible(false);
                    }
                });
                heatmapDataTableReInitialize();
            }
        }
        function heatMapSwitch(type) {
            if (type == 'type1') {
                $('#HeatmapToggleevent').click();
            }
            else {
                SrViewModel.heatMapView() == true ? SrViewModel.heatMapView(false) : SrViewModel.heatMapView(true);
                heatmapDataTableReInitialize();
            }
        }
        function heatMapSwitchNA(type) {
            if (type == 'typeNA') {
                $('#HeatmapToggleeventNA').click();
            }
            else {
                SrViewModel.heatMapViewNA() == true ? SrViewModel.heatMapViewNA(false) : SrViewModel.heatMapViewNA(true);
                heatmapDataTableReInitialize();
            }
        }

        function OverrideRequestSSRS() {
            try {

                $('#divRequestOverrideReport').html('');
                var homeurl = homeUrlLocation;
                var url = window.location.pathname;
                    $('<iframe>', {
                        src: homeurl + 'SSRSRequestOverrideSocialization.aspx?DERAT_UID=' + SrViewModel.BusinessUnitId() + '&UserId=' + SrViewModel.User(),
                        id: 'iframe_FINDINGS',
                        frameborder: 0,
                        style: 'display: block; width: 100%; height: 1500px; margin-left: 0px;',
                    }).appendTo('#divRequestOverrideReport');

                $('#RequestOverridePopUp').modal('show');
                $('#modalContent').css({
                    'margin-top': '25%'
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OverrideRequestSSRS() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function GetActions() {
            SrViewModel.SurveyActionsListValidation([]);
            $.ajax({
                url: "/api/Configuration/GetActionsList?BuId=" + SrViewModel.BusinessUnitId() + "&RoleId=" + appsecurity.userInfo().PrimaryRoleId(),
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            }).success(function (jsonResult, success) {
                var mappedActionsList;
                if (jsonResult.validation != null) {
                    mappedActionsList = $.map(jsonResult.validation, function (result) {
                        return new SurveyActionsValidationModel(result);
                    });
                    SrViewModel.SurveyActionsListValidation(mappedActionsList);
                }
                if (jsonResult.surveyResponseActionModel != null) {
                    mappedActionsList = $.map(jsonResult.surveyResponseActionModel, function (result) {
                        return new SurveyActionsModel(result);
                    });
                    SrViewModel.SurveyActionsList(mappedActionsList);
                    $('#divActionError').hide();
                    $('#ActionsPopUp').modal('show');
                }
            });
        }
        function btnClickPerformAction(data, event) {
            if ($('input[name=rdbAction]:checked').val() != undefined) {
                $('#divActionError').hide();
                PerformSurveyAction();
            }
            else {
                $('#divActionError label').text("Please select an action to perform.");
                $('#divActionError').show();
            }
        }
        function PerformSurveyAction() {
            try {
                var parameters = ko.utils.arrayFilter(SrViewModel.SurveyActionsListValidation(), function (parameter) {
                    if (parseInt(parameter.EVENT_ID()) == parseInt($('input[name=rdbAction]:checked').val())) {
                        if (parameter.ERROR_STATUS() != 0) {
                            return true;
                        }
                    }
                });
                if (parameters.length > 0 && parameters[0] != null) {
                    $('#divActionError label').html(parameters[0].ERROR_MESSAGE());
                    $('#divActionError').show();
                    return;
                }
                $('#ActionsPopUp').modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/SetPerformAction?EventId=" + $('input[name=rdbAction]:checked').val() + "&BuId=" + SrViewModel.BusinessUnitId() + "&RoleId=" + appsecurity.userInfo().PrimaryRoleId(),
                    headers: headers,
                    type: "POST",
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in PerformSurveyAction() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult == 1) {
                        logger.logSuccess('Survey action performed successfully.', 'Success', system.getModuleId(SrViewModel), true);
                        router.navigate("#RaSocialization/DashBoard", true);
                    }
                    else if (jsonResult < 1)
                        logger.logError('An error occurred while performing selected survey action.', 'Error', system.getModuleId(SrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in PerformSurveyAction() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            };

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in PerformSurveyAction() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in PerformSurveyAction() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            };
        }

        function OcKeypress(data, event) {
            try {
                if (event.which == 16 || event.which == 17 || event.which == 18 || (event.which >= 112 && event.which <= 123) || event.which == 35 || event.which == 36 || event.which == 46 || event.which == 8)
                    return true;
                else {
                    if (event.currentTarget.value.length >= SrViewModel.OverrideCommentsCharsLimit()) {
                        return false;
                    }

                    return true;
                }
            }
            catch (e) {
                var msg = 'exception' + e + 'source in OcKeypress() in InherentHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function GetTaxonomyList() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetTaxonomyListForSocialization",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        "PageType": 'SO',
                    },
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetTaxonomyList() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {

                    if (jsonResult != null) {
                        var mappedList = $.map(jsonResult, function (result) {
                            return new TaxonomyModel(result);
                        });
                            SrViewModel.TaxonomyLevelList([]);
                        SrViewModel.TaxonomyLevelList(mappedList);

                        if (SrViewModel.TaxonomyLevelList() != undefined || SrViewModel.TaxonomyLevelList().length > 0) {
                            SrViewModel.SelectedTaxonomyOptionText(SrViewModel.TaxonomyLevelList()[0].TaxonomyName());
                            SrViewModel.SelectedTaxonomyOptionRefresh(SrViewModel.TaxonomyLevelList()[0].TaxonomyId());
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetTaxonomyList() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetTaxonomyList() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetTaxonomyList() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            };
        }

        function TaxonomyModel(item) {
            try {
                var self = this;
                self.TaxonomyId = ko.observable(item.TaxonomyId);
                self.TaxonomyName = ko.observable($('<div/>').html(item.TaxonomyName).text());
                self.LevelId = ko.observable($('<div/>').html(item.LevelId).text());
                self.LevelMapId = ko.observable($('<div/>').html(item.LevelMapId).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: TaxonomyModel() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }
        }

        function GetHeatmapDataForTaxonomy(){
            TaxonomyTypeSelected();
        }
        function TaxonomyTypeSelected() {
            try {
                SrViewModel.contentTabVisible(false);
                if (SrViewModel.tabType() == 'HEATMAP_TYPE2' && $("#TaxonomyLevelsId").val() === '-999') {
                    SrViewModel.SelectedTaxonomyOptionFlag(true);
                } else {
                    SrViewModel.SelectedTaxonomyOptionFlag(false);
                }

                GetAllHeatmapData();
                SrViewModel.TaxonomyLevelListFlag(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: TaxonomyTypeSelected() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }
        }


        function StatusPopUpClick(data, event) {
            try {
                $('#SocializationStatusPopUp').modal('show');
                $('#loadingImgMainRC2').show();
                GetRoleUserDetailsForBU();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in StatusPopUpClick in Administration.js';
                logger.logMessage(msg);
            }
        }
        function btnCloseStatusPopup() {
            try {
                $('#SocializationStatusPopUp').modal('hide');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in btnCloseActionPopup in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function GetRoleUserDetailsForBU() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetRoleUserDetailsForBU",
                    data: {
                        "BuId": SrViewModel.BusinessUnitId(),
                    },
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, success) {
                        $('#loadingImgMainRC2').hide();
                        SrViewModel.workflowModelList([]);
                        if (jsonResult.length > 0 && jsonResult != null) {
                            SrViewModel.workflowModelList(jsonResult);
                        }
                    })
                    .fail(function (error, fail) { });
                $('#loadingImgMainRC2').hide();
            }
            catch (e) {
                $('#loadingImgMainRC2').hide();
                var msg = 'Exception: ' + e + ' | Source:ajax call in GetRRSDrpDwnList() method in AMLResidualRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }


        function OcKeyUp(data, event) {
            SrViewModel.OverrideCommentsChars(SrViewModel.OverrideCommentsCharsLimit() - event.currentTarget.value.length);
        }
        function NavigateToDashboard() {
            router.navigate("#RaSocialization/DashBoard", true);
        }
        function NavigateToAssignment() {
            router.navigate("#RaSocialization/Administration", true);
        }
        function SurveyActionsModel(item) {
            var self = this;
            self.EventId = ko.observable(item.EventId);
            self.EventName = ko.observable($('<div/>').html(item.EventName).text());
            self.NextState = ko.observable($('<div/>').html(item.NextState).text());
            self.IsMessage = ko.observable(item.IsMessage);
        }
        function SurveyActionsValidationModel(item) {
            var self = this;
            self.EVENT_ID = ko.observable(item.EVENT_ID);
            self.EVENT_NAME = ko.observable(item.EVENT_NAME);
            self.ERROR_STATUS = ko.observable(item.ERROR_STATUS);
            self.ERROR_MESSAGE = ko.observable(item.ERROR_MESSAGE);
        }
        function expandCollapseModel(item) {
            var self = this;
            self.colName = ko.observable("Collapse " + item.colType + " cells");
            self.isExpanded = ko.observable("table-cell");
            self.expand = function (data, e) {
                if (data.isExpanded() == "table-cell") {
                    self.colName = ko.observable("Expand " + item.colType + " cells");
                    self.isExpanded("none");
                }
                else {
                    self.colName = ko.observable("Collapse " + item.colType + " cells");
                    self.isExpanded("table-cell");
                }
            };
        }
        function heatMapDataModel(item) {
            var self = this;
            self.parentData = ko.observable(item);
            self.childrenData = ko.observable();
            if (item.childHeatMapData) {
                var mappedChildData = $.map(item.childHeatMapData, function (result) {
                    return new heatMapChildDataModel(result);
                });
                self.childrenData(mappedChildData);
            }
            self.childrenVisible = ko.observable(false);
            self.socCompRiskLevel = ko.observable(item.socCompRiskLevel);
            self.socCompRiskCss = ko.observable(item.socCompRiskCss);
            self.socCompRiskId = ko.observable(item.socCompRiskId);
            self.internalType = ko.observable(item.internalType);
            self.isEdit = ko.observable(item.isEdit);
            self.Show_Edit = ko.observable(item.Show_Edit);
            self.Refresh_ChangeFlag = ko.observable(item.Refresh_ChangeFlag);
            self.VisibleForChangeAreas = ko.observable(true);
            self.seeCategories = function (data, event) {
                if (self.childrenVisible() == false)
                    self.childrenVisible(true);
                else
                    self.childrenVisible(false);
            };
            self.setRiskColorValue = function (data, event) {
                if (!SrViewModel.readOnlyFlag()) {
                    SrViewModel.overrideCommentsDetails(new OverrideCommentModel(self, data));
                    SrViewModel.OverrideCommentsChars(4000);
                    $('#SetOverrideCommentsPopUp').modal('show');
                }
            };
            self.isEditForSharedCtrl = ko.observable(item.isEditForSharedCtrl);
        }

        function heatMapDataChangeModel(item) {
            var self = this;
            self.parentData = ko.observable(item);
            self.childrenData = ko.observable();
            if (item.childHeatMapData) {
                var mappedChildData = $.map(item.childHeatMapData, function (result) {
                    return new heatMapChildDataModel(result);
                });
                self.childrenData(mappedChildData);
            }
            self.childrenVisible = ko.observable(false);
            self.socCompRiskLevel = ko.observable(item.socCompRiskLevel);
            self.socCompRiskCss = ko.observable(item.socCompRiskCss);
            self.socCompRiskId = ko.observable(item.socCompRiskId);
            self.internalType = ko.observable(item.internalType);
            self.isEdit = ko.observable(item.isEdit);
            self.Show_Edit = ko.observable(item.Show_Edit);
            self.Refresh_ChangeFlag = ko.observable(item.Refresh_ChangeFlag);
            self.VisibleForChangeAreas = ko.observable(item.Refresh_ChangeFlag);
            self.seeCategories = function (data, event) {
                if (self.childrenVisible() == false)
                    self.childrenVisible(true);
                else
                    self.childrenVisible(false);
            };
            self.setRiskColorValue = function (data, event) {
                if (!SrViewModel.readOnlyFlag()) {
                    SrViewModel.overrideCommentsDetails(new OverrideCommentModel(self, data));
                    SrViewModel.OverrideCommentsChars(4000);
                    $('#SetOverrideCommentsPopUp').modal('show');
                }
            };
            self.isEditForSharedCtrl = ko.observable(item.isEditForSharedCtrl);
        }
        function requestModel(item) {
            var self = this;
            self.overrideDetail = ko.observable(item);
            self.approveOverride = function (data) {
                SrViewModel.approveDenyDetails(new approveDenyOverrideModel(self, data));
                $('#OverrideApprovalPopup').modal('show');
            };
            self.reqComment = function (data) {
                return $.ajax({
                    url: "/api/Configuration/GetAllCommentsOverrides",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { type: data.overrideDetail().type, socId: data.overrideDetail().socID }
                }).success(function (jsonResult, Success) {
                    var mappedcommentdetails = [];
                    if ($.fn.DataTable.isDataTable('#tboverrideCommentSection')) {
                        var table = $('#tboverrideCommentSection').DataTable();
                        table.destroy();
                        $("#tboverrideCommentSection tbody tr").remove();
                    }
                    if (jsonResult != null && jsonResult.length > 0) {
                        mappedcommentdetails = $.map(jsonResult, function (result) {
                            return new CommentsModel(result);
                        });
                    }
                    $('#tboverrideCommentSection').DataTable();
                    SrViewModel.overrideCommentsList(new editOverrideCommentModel({ tableUid: data.overrideDetail().socID, type: data.overrideDetail().type, Comment: '', CommentID: 0, modalLabel: 'Comments', theme: data.overrideDetail().name, commentsList: mappedcommentdetails }));
                    SrViewModel.OverrideCommentsChars(4000);
                    $('#OverrideCommentPopupRespRev').modal('show');
                });
            };
        }
        function addEditOverrideComment(isNew, data, event) {
            if (isNew == 0) {
                $('#valErrorActionRespRev').hide();
                SrViewModel.overrideCommentsList().isCommentEditable(data.isCommentEditable());
                SrViewModel.overrideCommentsList().commentID(data.commentID());
                SrViewModel.overrideCommentsList().Comment(data.comment());
                SrViewModel.overrideCommentsList().RoleType(data.roleName());
                SrViewModel.overrideCommentsList().UserName(data.addedBy());
                SrViewModel.OverrideCommentsChars(4000);
            }
            else {
                $('#valErrorActionRespRev').hide();
                SrViewModel.overrideCommentsList().isCommentEditable(true);
                SrViewModel.overrideCommentsList().commentID(0);
                SrViewModel.overrideCommentsList().Comment('');
                SrViewModel.overrideCommentsList().RoleType(SrViewModel.appsecurity.userInfo().PrimaryRoleName());
                SrViewModel.overrideCommentsList().UserName(SrViewModel.appsecurity.userInfo().lastName() + ", " + SrViewModel.appsecurity.userInfo().firstName());
                SrViewModel.OverrideCommentsChars(4000);
            }
        }
        function approveDenyOverrideModel(details, data) {
            var self = this;
            self.actionId = ko.observable();
            self.approveDenyComment = ko.observable();
            self.saveOverride = function () {

                $('#valErrorAction').hide();
                if (self.actionId() === undefined || self.actionId() === "") {
                    $('#valErrorAction').html('Please select an action.');
                    $('#valErrorAction').show();
                    return;
                }

                if (self.approveDenyComment() === undefined || self.approveDenyComment() === "") {
                    $('#valErrorAction').html('Comment is required.');
                    $('#valErrorAction').show();
                    return;
                }
                var comment = self.approveDenyComment();
                var statusId = self.actionId();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Configuration/ApproveDenyOverride",
                    type: "POST",
                    headers: headers,
                    data: {
                        deRatUid: SrViewModel.BusinessUnitId(),
                        type: data.overrideDetail().type,
                        comment: comment,
                        socId: data.overrideDetail().socID,
                        statusId: statusId
                    }
                }).success(function (jsonResult, success) {
                    if (jsonResult != null && jsonResult > 0) {
                        $('#OverrideApprovalPopup').modal('hide');
                        GetOverridesData()
                        logger.logSuccess('Override has been saved. Please submit the socialization survey of the assessment unit.', 'Success', system.getModuleId(SrViewModel), true);
                    } else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                    }
                });
            };
            self.cancelOverride = function () {
                $('#SetOverrideCommentsPopUp').modal('hide');
            };
        }
        function OverrideCommentModel(details, data) {
            try {
                var self = this;
                SrViewModel.ErrorChars('');
                self.overrideComment = ko.observable();
                self.saveOverrideComment = function () {
                    $("#loadingSaveImgDiv").show();
                    var comment = self.overrideComment();
                    if (comment == "" || comment == " " || comment == undefined) {
                        SrViewModel.ErrorChars('Please enter comments to save.');
                        $("#SetOverrideCommentsPopUp").show();
                        $("#loadingSaveImgDiv").hide();
                        return false;
                    }
                    $("#loadingActionItemList").show();
                    $('#OverrideCommentsFooterDiv').hide();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    return $.ajax({
                        url: "/api/Configuration/SaveComplianceOverrides",
                        type: "POST",
                        headers: headers,
                        data: {
                            deRatUid: SrViewModel.BusinessUnitId(),
                            calcUid: (details.parentData != undefined ? details.parentData().calcId : details.childData().calcId),
                            type: data.type,
                            comment: comment,
                            complianceUid: data.riskLevelId
                        }
                    })
                        .success(function (jsonResult, success) {
                            if (jsonResult != null && jsonResult > 0) {
                                SrViewModel.ErrorChars('');
                                SrViewModel.contentTabVisible(false);
                                GetAllHeatmapData();
                                $("#loadingSaveImgDiv").hide();
                                details.socCompRiskLevel(data.riskLevelName);
                                details.socCompRiskCss(data.riskLevelCss);
                                details.socCompRiskId(data.riskLevelId);
                                $('#SetOverrideCommentsPopUp').modal('hide');
                                logger.logSuccess('Override has been saved. Please submit the socialization survey of the assessment unit.', 'Success', system.getModuleId(SrViewModel), true);
                            } else {
                                SrViewModel.ErrorChars('Please enter comments to save.');
                                $("#loadingSaveImgDiv").hide();
                                $("#SetOverrideCommentsPopUp").show();
                                return false;
                            }
                        });
                };
                self.cancelOverrideComment = function () {
                    $('#SetOverrideCommentsPopUp').modal('hide');
                    $("#loadingSaveImgDiv").hide();
                };
            }
             catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in OverrideCommentModel() method in SR.js';
                    logger.logMessage(msg);
                }
        }
        function heatMapChildDataModel(item) {
            var self = this;
            self.childData = ko.observable(item);
            self.socCompRiskLevel = ko.observable(item.socCompRiskLevel);
            self.socCompRiskCss = ko.observable(item.socCompRiskCss);
            self.socCompRiskId = ko.observable(item.socCompRiskId);
            self.isEdit = ko.observable(item.isEdit);
            self.Show_Edit = ko.observable(item.Show_Edit);

            self.setRiskColorValue = function (data, event) {
                if (!SrViewModel.readOnlyFlag()) {
                    SrViewModel.overrideCommentsDetails(new OverrideCommentModel(self, data));
                    SrViewModel.OverrideCommentsChars(4000);
                    $('#SetOverrideCommentsPopUp').modal('show');
                }
            };
            self.internalType = ko.observable(item.internalType);
            self.Refresh_ChangeFlag = ko.observable(item.Refresh_ChangeFlag);
            self.VisibleForChangeAreas = ko.observable(true);

        }
        function ResponseMoveModel(item) {
            var self = this;
            self.SurveyProfileId = ko.observable(item.SurveyProfileId);
            self.SurveyTypeId = ko.observable(item.SurveyTypeId);
            self.PageHeaderName = ko.observable(item.PageHeaderName);
            self.BusinessUnitId = ko.observable(item.BusinessUnitId);
            self.BusinessUnitName = ko.observable(item.BusinessUnitName);
            self.BusinessUnitDescription = ko.observable(item.BusinessUnitDescription);
            self.SurveyType = ko.observable(item.SurveyType);
            self.SurveyId = ko.observable(item.SurveyId);
            self.RoleId = ko.observable(item.RoleId);
            self.RoleName = ko.observable(item.RoleName);
            self.SurveyStatus = ko.observable(item.SurveyStatus);
            self.areaId = ko.observable(item.areaId);
        }
        function CommentsModel(item) {
            var self = this;
            self.commentID = ko.observable(item.commentID);
            self.addedBy = ko.observable(item.addedBy);
            self.comment = ko.observable(item.comment);
            self.addedByID = ko.observable(item.addedByUserID);
            self.commentAddedOn = ko.observable(item.commentAddedOn);
            self.roleName = ko.observable(item.roleName);
            self.isCommentEditable = ko.observable(item.isCommentEditable);
        }
        function editOverrideCommentModel(item) {
            var self = this;
            self.isCommentEditable = ko.observable(true);
            self.RoleType = ko.observable(appsecurity.userInfo().PrimaryRoleName());
            self.UserName = ko.observable(SrViewModel.appsecurity.userInfo().lastName() + ", " + SrViewModel.appsecurity.userInfo().firstName());
            self.commentID = ko.observable(0);
            self.Comment = ko.observable(item.Comment);
            self.tableUid = ko.observable(item.tableUid);
            self.type = ko.observable(item.type);
            self.modalLabel = ko.observable(item.modalLabel);
            self.theme = ko.observable(item.theme);
            self.editOverrideRequest = function (data, event) {

                $('#valErrorActionRespRev').hide();
                if (self.Comment() === undefined || self.Comment() === "") {
                    $('#valErrorActionRespRev').html('Comment is required.');
                    $('#valErrorActionRespRev').show();
                    return;
                }

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Configuration/EditOverrideRequestComment",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: JSON.stringify({
                        TABLE_UID: self.tableUid(),
                        TYPE: self.type(),
                        roleId: appsecurity.userInfo().PrimaryRoleId(),
                        comment: self.Comment(),
                        commentID: self.commentID()
                    })
                }).success(function (jsonResult, success) {
                    if (jsonResult != null && jsonResult > 0) {
                        logger.logSuccess('Comment has been saved successfully.', 'Success', system.getModuleId(SrViewModel), true);
                        getComments(self.type(), self.tableUid());
                        self.Comment("");
                    }
                });
            };
            self.deleteOverrideRequest = function (data, event) {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Configuration/DeleteOverrideRequestComment?commentID=" + data.commentID(),
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json'
                }).success(function (jsonResult, success) {
                    if (jsonResult != null && jsonResult > 0) {
                        logger.logSuccess('Comment has been deleted successfully.', 'Success', system.getModuleId(SrViewModel), true);
                        getComments(self.type(), self.tableUid());
                        self.Comment("");
                    }
                });
            };
            self.commentList = ko.observableArray(item.commentsList);
        }
        function getComments(type, socID) {
            return $.ajax({
                url: "/api/Configuration/GetAllCommentsOverrides",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { type: type, socId: socID }
            }).success(function (jsonResult, Success) {
                var mappedcommentdetails = [];
                if ($.fn.DataTable.isDataTable('#tboverrideCommentSection')) {
                    var table = $('#tboverrideCommentSection').DataTable();
                    table.destroy();
                    $('#tboverrideCommentSection tbody tr').remove();
                }
                if (jsonResult != null && jsonResult.length > 0) {
                    mappedcommentdetails = $.map(jsonResult, function (result) {
                        return new CommentsModel(result);
                    });
                }
                if (SrViewModel.overrideCommentsList()) {
                    SrViewModel.overrideCommentsList().commentList(mappedcommentdetails);
                }
                SrViewModel.OverrideCommentsChars(4000);
                SrViewModel.overrideCommentsList(new editOverrideCommentModel({ tableUid: data.overrideDetail().socID, type: data.overrideDetail().type, Comment: '', CommentID: 0, modalLabel: 'Comments', theme: data.overrideDetail().name, commentsList: mappedcommentdetails }));
                $('#tboverrideCommentSection').DataTable({ paging: false });
            });
        }

        //=--------------------------------Socialization surveys ------------------------------//
        function GetQualResponseDetails(tableUID) {
            try {
                $('#loadingImgOrCalc').show();
                $('#InnerInherentTabDiv').html("");
                $('#InnerInherentTabDiv111').html("");
                var zat_id = tableUID;
                $.ajax({
                    url: "/api/Configuration/GetQualitativeResponseDataByBU",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        DeRatId: SrViewModel.BusinessUnitId(), Table_Uid: zat_id, Type: SrViewModel.ClickedQualType(), AreaId: SrViewModel.ClickedRiskAreaId()
                    }
                })
                    .success(function (JsonResult, Success) {
                        if (JsonResult != null && JsonResult.length > 0) {
                            $('#NoSurveyError').hide();
                            $('#NoRiskAreaError').hide();
                            SrViewModel.QualResponseListData([]);
                            SrViewModel.QualResponseListData(JsonResult);
                            SrViewModel.inhHeatMapDrpDwn();

                            SrViewModel.DistinctRiskLevelList([]);
                            SrViewModel.DistinctRiskLevelList(SrViewModel.inhHeatMapDrpDwn());
                            BindDynamicFilter();
                            BindDynamicHtmlQualitative();
                        }
                        else {
                            $('#loadingImgOrCalc').hide();
                            $('#InnerInherentTabDiv').html('');
                            $('#InnerInherentTabDiv111').html('');
                            $('#InnerInherentTabDiv').html('<span class="">No data is available.</span>');
                            $('#NoSurveyError').hide();
                            $('#NoRiskAreaError').show();
                            $('#loadingImgMain').hide();
                        }
                    })
                    .fail(function (error, fail) {
                        $('#loadingImgOrCalc').hide();
                    });
            }
            catch (e) {

                var msg = 'Exception: ' + e + ' | Source: GetQualResponseDetails() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        function BindDynamicHtmlQualitative() {
            try {
                var QualDynamicHTML = "";
                var marginLeft = "2.8rem";
                var marginLeftQuestion = "2rem";
                $("#TaxonomyLId").show();
            
                for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                    QualDynamicHTML = '<div class="mainQualResponses col-md-12 col-lg-12" style="border: 2px solid #0076A8;display: inline-block;padding: 1rem;">';
                    for (var j = 0; j < SrViewModel.QualResponseListData()[i].length; j++) {
                        for (var k = 0; k < SrViewModel.QualResponseListData()[i][j].length; k++) {

                            if (SrViewModel.QualResponseListData()[i][j][k].IsVisibleforSearch == true) {

                                if (k == 0) {
                                    QualDynamicHTML += '<div class="col-md-12 no-padding" style="display:flex;margin-bottom: 0.5rem;">'
                                    if (j == 0 && k == 0) {
                                        QualDynamicHTML += '<label id="NarTheme" style="font-size: 16px;" title="Theme">' + SrViewModel.QualResponseListData()[i][0][0].ThemeName + '</label>'
                                        QualDynamicHTML += '&nbsp;&nbsp;<i class="fa fa-chevron-right" style="padding-top: 0.6rem;" aria-hidden="true"></i>&nbsp;&nbsp;'
                                    }
                                    QualDynamicHTML += '<label id="NarCategory"  title="Category" style="padding-top: 0.1rem;font-size: 13px;font-weight: 700;">' + SrViewModel.QualResponseListData()[i][j][0].CategoryName + '</label>'
                                    QualDynamicHTML += '</div>'
                                }

                                QualDynamicHTML += '<div style="margin-bottom: 1.5rem;margin-top:0.5rem;">'
                                if (SrViewModel.QualResponseListData()[i][j][k].IsHeader == 0) {
                                    QualDynamicHTML += '<div class="col-md-12" style="display:flex;font-weight: 600;">'
                                    marginLeft = "2.8rem";
                                    QualDynamicHTML += '<span class="" id="QuestionId" style="float: left;"></span>'
                                    QualDynamicHTML += '<span class="col-md-11"  title="Question" id="QuestionText" style="margin-left: ' + marginLeftQuestion + ';">' + SrViewModel.QualResponseListData()[i][j][k].QuestionText + '</span>'
                                    QualDynamicHTML += '</div>'
                                }
                                else if (SrViewModel.QualResponseListData()[i][j][k].IsHeader == 1) {
                                    QualDynamicHTML += '<h5 class="col-md-12" style="display:flex;margin-bottom:2rem;">'
                                    marginLeft = "3.8rem";
                                    QualDynamicHTML += '<span class="col-md-11"  title="Header Question" id="QuestionText" style="margin-left: ' + marginLeftQuestion + ';">' + SrViewModel.QualResponseListData()[i][j][k].QuestionText + '</span>'
                                    QualDynamicHTML += '</h5>'
                                }

                                QualDynamicHTML += '<div class="col-md-12" style="display:flex;">'
                                if (SrViewModel.QualResponseListData()[i][j][k].IsHeader == 0) {
                                    var ColumnName = "Response";
                                    if (SrViewModel.QualResponseListData()[i][j][k].QualResponseObject[0].Applicability === true) {
                                        QualDynamicHTML += '<div class="col-md-11" style="display:block;margin: 1rem;margin-left: ' + marginLeft + ';">'
                                        QualDynamicHTML += '<div>'
                                        QualDynamicHTML += '<span class="" id="QuestionId">' + ColumnName + '</span>'
                                        QualDynamicHTML += '<div  style="margin-top: .4rem;">';
                                        QualDynamicHTML += '<textarea rows="2" class="form-control" disabled >' + SrViewModel.QualResponseListData()[i][j][k].QualResponseObject[0].ResponseValue + '</textarea>';
                                        QualDynamicHTML += '</div>'
                                        QualDynamicHTML += '</div>'
                                        QualDynamicHTML += '</div>'
                                    }
                                }
                                QualDynamicHTML += '</div>'
                            }
                        }
                    }
                }
                QualDynamicHTML += '</div>'

                $('#InnerInherentTabDiv').html("");
                $('#InnerInherentTabDiv').html(QualDynamicHTML);

                $('#NoSurveyError').hide();
                $('#NoRiskAreaError').hide();
                $('#lblNoResponseComment').hide();
                $('#InnerInherentTabDiv').show();


                if (QualDynamicHTML != "")
                    $("#TaxonomyLId").hide();

                $('#loadingImgOrCalc').hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetQualResponseDetails() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        function GetControlResponseDetails(tableUID) {
            try {
                $('#loadingImgOrCalc').show();
                $('#InnerInherentTabDiv').html("");
                $('#InnerInherentTabDiv111').html('');
                var zat_id = tableUID;
                $.ajax({
                    url: "/api/Configuration/GetControlsResponseDataByBU",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        DeRatId: SrViewModel.BusinessUnitId(), Table_Uid: zat_id, AreaId: SrViewModel.ClickedRiskAreaId()
                    }
                }).success(function (JsonResult, success) {

                    if (JsonResult != null && JsonResult.length > 0) {
                        $('#NoSurveyError').hide();
                        $('#NoRiskAreaError').hide();

                        SrViewModel.ControlsResponseData(JsonResult);
                        SrViewModel.cntrlHeatMapDrpDwn();

                        SrViewModel.DistinctRiskLevelList([]);
                        SrViewModel.DistinctRiskLevelList(SrViewModel.cntrlHeatMapDrpDwn());
                        BindDynamicFilter();


                        BindDynamicHtmlForControls();
                    }
                    else {
                        $('#loadingImgOrCalc').hide();
                        $('#InnerInherentTabDiv').html('');
                        $('#InnerInherentTabDiv111').html('');
                        $('#InnerInherentTabDiv111').html('<span class="">No data is available.</span>');
                        $('#InnerControlsTabDiv').hide();
                        $('#NoSurveyError').hide();
                        $('#NoRiskAreaError').show();
                        $('#loadingImgMain').hide();

                    }
                })
                    .fail(function (fail, error) {
                        $('#loadingImgOrCalc').hide();
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetControlResponseData() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        function BindDynamicHtmlForControls() {
            try {
                var ContDynamicHTML = "";
                var marginLeft = "2.8rem";
                var marginLeftQuestion = "2rem";
                $("#TaxonomyLId").show();
                $('#loadingImgOrCalc').show();
               
                for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                    ContDynamicHTML = '<div class="mainContResponses col-md-12 col-lg-12" style="border: 2px solid #0076A8;display: inline-block;padding: 1rem;">';
                    for (var j = 0; j < SrViewModel.ControlsResponseData()[i].length; j++) {
                        for (var k = 0; k < SrViewModel.ControlsResponseData()[i][j].length; k++) {
                            if (SrViewModel.ControlsResponseData()[i][j][k].IsVisibleforSearch == true) {
                             
                                if (k == 0) {
                                    ContDynamicHTML += '<div class="col-md-12 no-padding" style="display:flex;margin-bottom: 0.5rem;">'
                                    if (j == 0 && k == 0) {
                                        ContDynamicHTML += '<label id="NarTheme" style="font-size: 16px;" title="Theme">' + SrViewModel.ControlsResponseData()[i][0][0].ThemeName + '</label>'
                                        ContDynamicHTML += '&nbsp;&nbsp;<i class="fa fa-chevron-right" style="padding-top: 0.6rem;" aria-hidden="true"></i>&nbsp;&nbsp;'
                                    }
                                    ContDynamicHTML += '<label id="NarCategory"  title="Category" style="padding-top: 0.1rem;font-size: 13px;font-weight: 700;">' + SrViewModel.ControlsResponseData()[i][j][0].CategoryName + '</label>'
                                    ContDynamicHTML += '</div>'
                                }
                                ContDynamicHTML += '<div style="margin-bottom: 1.5rem;">'
                                if (SrViewModel.ControlsResponseData()[i][j][k].IsHeader == 0) {
                                    ContDynamicHTML += '<div class="col-md-12" style="display:flex;font-weight: 600;" title="Question">'
                                    ContDynamicHTML += '<span class="col-md-11" id="QuestionText" style="margin-left: ' + marginLeftQuestion + ';">' + SrViewModel.ControlsResponseData()[i][j][k].QuestionText + '</span>'
                                    ContDynamicHTML += '</div>'
                                }
                                else if (SrViewModel.ControlsResponseData()[i][j][k].IsHeader == 1) {
                                    ContDynamicHTML += '<h5 class="col-md-12" style="display:flex;margin-bottom:0.5rem;font-weight: 600;" title="Header Question">'
                                    ContDynamicHTML += '<span class="col-md-11" id="QuestionText" style="margin-left: ' + marginLeftQuestion + ';">' + SrViewModel.ControlsResponseData()[i][j][k].QuestionText + '</span>'
                                    ContDynamicHTML += '</h5>'
                                }

                                ContDynamicHTML += '<div class="col-md-12" style="display:flex;">'
                                if (SrViewModel.ControlsResponseData()[i][j][k].IsHeader == 0) {

                                    if (SrViewModel.ControlsResponseData()[i][j][k].ResposneObejct[0].ResponseApplicability_cd === 1) {
                                        ContDynamicHTML += '<div class="col-md-11" style="display:block;margin-top: .4rem;margin-left: ' + marginLeft + ';">'
                                        ContDynamicHTML += '<textarea style="margin-bottom: 0.5rem;" rows="2" class="form-control" disabled >' + SrViewModel.ControlsResponseData()[i][j][k].ResposneObejct[0].Response_cd + '</textarea>';
                                        ContDynamicHTML += '</div>'
                                    }
                                    if (SrViewModel.ControlsResponseData()[i][j][k].ResposneObejct[0].ResponseApplicability_ce === 1) {
                                        ContDynamicHTML += '<div class="col-md-11" style="display:block;margin-top: .4rem;margin-left: ' + marginLeft + ';">'
                                        ContDynamicHTML += '<textarea style="margin-bottom: 0.5rem;" rows="2" class="form-control" disabled >' + SrViewModel.ControlsResponseData()[i][j][k].ResposneObejct[0].Response_ce + '</textarea>';
                                        ContDynamicHTML += '</div>'
                                    }
                                }
                                ContDynamicHTML += '</div>'
                                ContDynamicHTML += '</div>'
                            }
                        }
                    }
                }
                ContDynamicHTML += '</div>'

                $('#InnerInherentTabDiv111').html("");
                $('#InnerInherentTabDiv111').html(ContDynamicHTML);
                $('#loadingImgOrCalc').hide();
                $('#NoSurveyError').hide();
                $('#NoRiskAreaError').hide();
                $('#lblNoResponseComment').hide();
                $('#InnerInherentTabDiv111').show();

                if (ContDynamicHTML != "")
                    $("#TaxonomyLId").hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetQualResponseDetails() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        function BindDynamicFilter() {
            try {
                var DynamicHtml = "";
                DynamicHtml = ' <div class="dropdown pull-right">' +
                    '<button id="myValueDropdownSort" data-bind="click: FormatValueData" class="dropbtn" style="font-family:Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif;">Filter<span class="fa fa-chevron-down" style="margin-left: 4px;"></span></button>' +
                    '<div id="myValueDropdown" class="dropdown-content">';
                for (var i = 0; i < SrViewModel.DistinctRiskLevelList().length; i++) {
                    DynamicHtml += '<a href="#" id="' + SrViewModel.DistinctRiskLevelList()[i].riskLevelName.replace(/\s/g, '') + '" data-bind="click: $root.valuechange"><i class="fa fa-check" id="' + SrViewModel.DistinctRiskLevelList()[i].riskLevelName.replace(/\s/g, '') + 'CR" aria-hidden="true" style="display:none;margin-left: -1.1rem;margin-top: 3px;"></i><span style="margin-left:8px;">' + SrViewModel.DistinctRiskLevelList()[i].riskLevelName + '</span></a>';
                }
                DynamicHtml += '<span class="empty">&nbsp;</span>' +
                    '<a href="#" id="Resettodefault" data-bind="click: $root.valuechange" style="font-weight: 600;"><span style="margin-left:8px;">Reset to default</span></a>' +
                    '</div>' +
                    '</div>';

                $('#FilterDiv').html("");
                $('#FilterDiv').html(DynamicHtml);

                var element = $('#FilterDiv')[0];
                ko.cleanNode(element);
                ko.applyBindings(SrViewModel, document.getElementById('FilterDiv'));
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BindDynamicFilter() method in Activity.js';
                logger.logMessage(msg);
            }
        }


        //Filter code starts here
        function valuechange(data, event) {
            try {
                $("#TaxonomyLId").show();
                var optionValue = event.currentTarget.id;
                if ($('#' + event.currentTarget.id).children() != undefined && $('#' + event.currentTarget.id).children()[1] != undefined
                    && $('#' + event.currentTarget.id).children()[1].innerText != undefined && $('#' + event.currentTarget.id).children().innerText != 'NA') {
                    optionValue = $('#' + event.currentTarget.id).children()[1].innerText;
                }

                if (!($('#' + event.currentTarget.id + 'CR').is(":visible"))) {
                    SrViewModel.RemoveArray().push(optionValue);
                    $('#' + event.currentTarget.id + 'CR').show();
                }
                else {
                    SrViewModel.RemoveArray.remove(optionValue);
                    $('#' + event.currentTarget.id + 'CR').hide();
                }
                if (SrViewModel.ClickedSurveyTypeText().toLowerCase() == 'qldr') {
                    if (event.currentTarget.id != "Resettodefault") {

                        for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {

                            for (var j = 0; j < SrViewModel.QualResponseListData()[i].length; j++) {
                                for (var k = 0; k < SrViewModel.QualResponseListData()[i][j].length; k++) {
                                    var counter = 0;
                                    if (SrViewModel.RemoveArray().length != 0) {
                                        for (var h = 0; h < SrViewModel.RemoveArray().length; h++) {
                                            if (SrViewModel.QualResponseListData()[i][j][k].QualResponseObject[0].RiskLevelDescription.replace(/\s/g, '').toLowerCase() == SrViewModel.RemoveArray()[h].replace(/\s/g, '').toLowerCase()) {
                                                counter++
                                            }
                                        }
                                    }
                                    else {
                                        counter++;
                                    }
                                    if (counter > 0) {
                                        SrViewModel.QualResponseListData()[i][j][k].IsVisibleforSearch = true;
                                    } else {
                                        SrViewModel.QualResponseListData()[i][j][k].IsVisibleforSearch = false;
                                    }
                                }
                            }
                        }
                    }
                    else {
                        $.map(SrViewModel.QualResponseListData(), function (item) {
                            $.map(item, function (result) {
                                $.map(result, function (result1) {
                                    if (SrViewModel.RemoveArray().length != 0) {
                                        result.IsVisibleforSearch = true;
                                        result1.IsVisibleforSearch = true;
                                    }
                                })
                            })
                        })
                        for (var i = 0; i < SrViewModel.DistinctRiskLevelList().length; i++) {
                            $('#' + SrViewModel.DistinctRiskLevelList()[i].riskLevelName.replace(/\s/g, '') + "CR").hide();
                        }
                        SrViewModel.RemoveArray([]);
                    }
                    BindDynamicHtmlQualitative();
                }
                else if (SrViewModel.ClickedSurveyTypeText().toLowerCase() == 'cdr') {
                    if (event.currentTarget.id != "Resettodefault") {

                        for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {

                            for (var j = 0; j < SrViewModel.ControlsResponseData()[i].length; j++) {
                                for (var k = 0; k < SrViewModel.ControlsResponseData()[i][j].length; k++) {
                                    var counter = 0;
                                    if (SrViewModel.RemoveArray().length != 0) {
                                        for (var h = 0; h < SrViewModel.RemoveArray().length; h++) {
                                            if (SrViewModel.ControlsResponseData()[i][j][k].ResposneObejct[0].RiskLevelDescription_cd.replace(/\s/g, '').toLowerCase() == SrViewModel.RemoveArray()[h].replace(/\s/g, '').toLowerCase() ||
                                                SrViewModel.ControlsResponseData()[i][j][k].ResposneObejct[0].RiskLevelDescription_ce.replace(/\s/g, '').toLowerCase() == SrViewModel.RemoveArray()[h].replace(/\s/g, '').toLowerCase()) {
                                                counter++
                                            }
                                        }
                                    }
                                    else {
                                        counter++;
                                    }
                                    if (counter > 0) {
                                        SrViewModel.ControlsResponseData()[i][j][k].IsVisibleforSearch = true;
                                    } else {
                                        SrViewModel.ControlsResponseData()[i][j][k].IsVisibleforSearch = false;
                                    }
                                }
                            }
                        }
                    }
                    else {
                        $.map(SrViewModel.ControlsResponseData(), function (item) {
                            $.map(item, function (result) {
                                $.map(result, function (result1) {
                                    if (SrViewModel.RemoveArray().length != 0) {
                                        result.IsVisibleforSearch = true;
                                        result1.IsVisibleforSearch = true;
                                    }
                                })
                            })
                        })

                        for (var i = 0; i < SrViewModel.DistinctRiskLevelList().length; i++) {
                            $('#' + SrViewModel.DistinctRiskLevelList()[i].riskLevelName.replace(/\s/g, '') + "CR").hide();
                        }
                        SrViewModel.RemoveArray([]);
                    }
                    BindDynamicHtmlForControls();
                }
            }
            catch (e) {
                $("#TaxonomyLId").hide();
                var msg = 'Exception: ' + e + ' | Source: valuechange() method in Activity.js';
                logger.logMessage(msg);
            }
        }
        function FormatValueData(data, event) {
            $('#myDropdown').removeClass('show')
            $('#myDropdownSort').removeClass('open')
            document.getElementById("myValueDropdown").classList.toggle("show");
            document.getElementById("myValueDropdownSort").classList.toggle("open");
        }

        function BindDynamicLevels() {
            try {
                var DynamicHtml = "";
                DynamicHtml = ' <div class="dropdown pull-right">' +
                    '<button id="myValueDropdownSortLevel" data-bind="click: FormatValueDataLevel" class="dropbtn" title="Change the level" style="padding-right: 0.7rem; font-family:Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif;">Levels ' +
                    '<span style="font-size: 13px;color: gray;font-family: Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif;margin-top: 0.5rem;"> - ' + SrViewModel.SelectedTaxonomyOptionText() + '</span> <span class="fa fa-chevron-down" style="margin-left: 4px;"></span>' +
                    '<div id="myValueDropdownLevel" class="dropdown-content" style="min-width: 26rem;">';
                for (var i = 0; i < SrViewModel.TaxonomyLevelList().length; i++) {
                    DynamicHtml += '<a href="#" id="' + SrViewModel.TaxonomyLevelList()[i].LevelMapId().replace(/\s/g, '') + '" data-bind="click: $root.valuechangeLevel"><i class="fa fa-check" id="' + SrViewModel.TaxonomyLevelList()[i].TaxonomyName().replace(/\s/g, '') + 'TL" aria-hidden="true" style="display:none;margin-left: -1.1rem;margin-top: 3px;"></i><span style="margin-left:8px;">' + SrViewModel.TaxonomyLevelList()[i].TaxonomyName() + '</span></a>';
                }
                   '</div>' +
                    '</div>';

                $('#LevelsDiv').html("");
                $('#LevelsDiv').html(DynamicHtml);

                var element = $('#LevelsDiv')[0];
                ko.cleanNode(element);
                ko.applyBindings(SrViewModel, document.getElementById('LevelsDiv'));
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BindDynamicLevels() method in SR.js';
                logger.logMessage(msg);
            }
        }

        function valuechangeLevel(data, event) {
            try {
                var optionId = event.currentTarget.id;
                $('#heatmapNAToggleDiv').show();
                SrViewModel.ChangesTabClick(false);
                if (event.currentTarget.firstElementChild.style.display === "none") {
                    event.currentTarget.firstElementChild.style.display = "inline-block"
                }
                else {
                    event.currentTarget.firstElementChild.style.display = "none";
                }
                if (SrViewModel.tabType() == 'HEATMAP_TYPE2' && optionId === '-999') {
                    SrViewModel.SelectedTaxonomyOptionFlag(true);
                } else {
                    SrViewModel.SelectedTaxonomyOptionFlag(false);
                }

                SrViewModel.SelectedTaxonomyOptionText(event.currentTarget.innerText);
                SrViewModel.SelectedTaxonomyOption(optionId);
                SrViewModel.SelectedTaxonomyOptionRefresh(optionId);
                SrViewModel.contentTabVisible(false);

                if (optionId === '-9999') {
                    SrViewModel.SelectedTaxonomyOption(0);
                    $('#heatmapNAToggleDiv').hide();
                    SrViewModel.ChangesTabClick(true);
                }
                    GetAllHeatmapData();

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: valuechange() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        function FormatValueDataLevel(data, event) {
            $('#myDropdown').removeClass('show');
            $('#myDropdownSort').removeClass('open');
            $('#myValueDropdown').removeClass('show');
            $('#myValueDropdownSort').removeClass('open');
            $('#ReportLinkDiv').removeClass('show');
            $('#ReportLinkDivBtn').removeClass('open')
            document.getElementById("myValueDropdownLevel").classList.toggle("show");
            document.getElementById("myValueDropdownSortLevel").classList.toggle("open");
        }

        function GetColumnDetails(type) {
            try {
                var DynUrl = "";
                if (type == 'cdr')
                    DynUrl = "/api/Survey/GetControlsColumnDetailsSocio";
                else
                    DynUrl = "/api/Survey/GetQualColumnDetailsSocio";

                return $.ajax({
                    url: DynUrl,
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { Type: SrViewModel.ClickedSurveyTypeText() }
                })
                    .success(function (jsonResult, success) {
                        SrViewModel.QualColumnDetails([]);
                        SrViewModel.ControlColumnDetails([]);
                        var mappedcolumndetails = $.map(jsonResult, function (result) {
                            if (type == 'cdr')
                                return new ControlsColumnDetailsModel(result);
                            else
                                return new QualColumnDetailsModel(result);
                        })
                        if (type == 'cdr') {
                            SrViewModel.ControlColumnDetails(mappedcolumndetails);
                        }
                        else
                            SrViewModel.QualColumnDetails(mappedcolumndetails);

                    })
                    .fail(function (fail, error) {

                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetQualColumnDetails() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        function ControlsColumnDetailsModel(item) {
            var self = this;
            self.ColumnId = ko.observable(item.ColumnId);
            self.Columntext = ko.observable($('<div/>').html(item.Columntext).text());
        }
        function QualColumnDetailsModel(item) {
            var self = this;
            self.ColumnId = ko.observable(item.ColumnId);
            self.ColumnName = ko.observable(item.ColumnName);
        }

        function SearchResult() {
            try {
                if (SrViewModel.ClickedSurveyTypeText() == "qldr") {
                    var searchedList = ko.observableArray([]);
                    var q = SrViewModel.Query();
                    if (q != "") {
                        for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                            for (var j = 0; j < SrViewModel.QualResponseListData()[i].length; j++) {
                                for (var k = 0; k < SrViewModel.QualResponseListData()[i][j].length; k++) {
                                    if (SrViewModel.QualResponseListData()[i][j][k].QuestionText.toLowerCase().indexOf(q.toLowerCase()) >= 0) {
                                        searchedList.push(SrViewModel.QualResponseListData()[i][j][k]);
                                    }
                                }
                            }
                        }
                    }

                    //make it false for all first
                    $.map(SrViewModel.QualResponseListData(), function (item) {
                        $.map(item, function (result) {
                            $.map(result, function (result1) {
                                result.IsVisibleforSearch = false;
                                result1.IsVisibleforSearch = false;
                            })
                        })
                    })

                    if (SrViewModel.Query() != undefined && SrViewModel.Query() == "") {
                        //for empty keyboard input
                        $.map(SrViewModel.QualResponseListData(), function (item) {
                            $.map(item, function (result) {
                                $.map(result, function (result1) {
                                    result.IsVisibleforSearch = true;
                                    result1.IsVisibleforSearch = true;
                                })
                            })
                        })
                    }

                    if (searchedList() != undefined) {
                        for (var h = 0; h < searchedList().length; h++) {
                            for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                                for (var j = 0; j < SrViewModel.QualResponseListData()[i].length; j++) {
                                    for (var k = 0; k < SrViewModel.QualResponseListData()[i][j].length; k++) {
                                        if (SrViewModel.QualResponseListData()[i][j][k].QuestionId == searchedList()[h].QuestionId) {
                                            SrViewModel.QualResponseListData()[i][j][k].IsVisibleforSearch = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    BindDynamicHtmlQualitative();
                }
                else if (SrViewModel.ClickedSurveyTypeText() == "cdr") {
                    var searchedListCn = ko.observableArray([]);
                    var q = SrViewModel.Query();
                    if (q != "") {
                        for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                            for (var j = 0; j < SrViewModel.ControlsResponseData()[i].length; j++) {
                                for (var k = 0; k < SrViewModel.ControlsResponseData()[i][j].length; k++) {
                                    if (SrViewModel.ControlsResponseData()[i][j][k].QuestionText.toLowerCase().indexOf(q.toLowerCase()) >= 0) {
                                        searchedListCn.push(SrViewModel.ControlsResponseData()[i][j][k]);
                                    }
                                }
                            }
                        }
                    }

                    //make it false for all first
                    $.map(SrViewModel.ControlsResponseData(), function (item) {
                        $.map(item, function (result) {
                            $.map(result, function (result1) {
                                result.IsVisibleforSearch = false;
                                result1.IsVisibleforSearch = false;
                            })
                        })
                    })

                    if (SrViewModel.Query() != undefined && SrViewModel.Query() == "") {
                        //for empty keyboard input
                        $.map(SrViewModel.ControlsResponseData(), function (item) {
                            $.map(item, function (result) {
                                $.map(result, function (result1) {
                                    result.IsVisibleforSearch = true;
                                    result1.IsVisibleforSearch = true;
                                })
                            })
                        })
                    }
                    if (searchedListCn() != undefined) {
                        for (var h = 0; h < searchedListCn().length; h++) {
                            for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                                for (var j = 0; j < SrViewModel.ControlsResponseData()[i].length; j++) {
                                    for (var k = 0; k < SrViewModel.ControlsResponseData()[i][j].length; k++) {
                                        if (SrViewModel.ControlsResponseData()[i][j][k].QuestionId == searchedListCn()[h].QuestionId) {
                                            SrViewModel.ControlsResponseData()[i][j][k].IsVisibleforSearch = true;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    BindDynamicHtmlForControls();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SearchResult() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ResetSearch() {
            try {
                $('#searchFeature').val('');
                if (SrViewModel.ClickedSurveyTypeText() == "qldr") {
                    $.map(SrViewModel.QualResponseListData(), function (item) {
                        $.map(item, function (result) {
                            $.map(result, function (result1) {
                                result.IsVisibleforSearch = true;
                                result1.IsVisibleforSearch = true;
                            })
                        })
                    })
                    BindDynamicHtmlQualitative();
                } else {
                    $.map(SrViewModel.ControlsResponseData(), function (item) {
                        $.map(item, function (result) {
                            $.map(result, function (result1) {
                                result.IsVisibleforSearch = true;
                                result1.IsVisibleforSearch = true;
                            })
                        })
                    })
                    BindDynamicHtmlForControls();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetSearch() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //////////////////////////////// --- Tree view code ---- ///////////////////////////////////
        function ToggleNavigationMenu1() {
            var chk2 = $('#NavigationToggle2');
            chk2.prop("checked", false);
            $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
            $("#bottomDivAreaType").toggleClass("col-lg-12 col-lg-9");
            $("#bottomDivAreaType").toggleClass("col-md-12 col-md-9");
            $("#bottomDivAreaType").toggleClass("col-sm-12 col-sm-9");
            $("#bottomDivAreaType").toggleClass("col-xs-12 col-xs-9");
            $("#divNavSwitch2").show();
            $("#divjsTree").hide();
        }
        function ToggleNavigationMenu2() {
            var chk1 = $('#NavigationToggle1');
            chk1.prop("checked", true);
            $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
            $("#bottomDivAreaType").toggleClass("col-lg-12 col-lg-9");
            $("#bottomDivAreaType").toggleClass("col-md-12 col-md-9");
            $("#bottomDivAreaType").toggleClass("col-sm-12 col-sm-9");
            $("#bottomDivAreaType").toggleClass("col-xs-12 col-xs-9");
            $("#divNavSwitch2").hide();
            $("#divjsTree").show();
        }
        function CollapseAllTreeView() {
            if ($('#spanExpandAll').text() == "Expand") {
                $('#jsTreeAreaLevel').treeview('collapseAll', { silent: true });
                $("#spanExpandAll").text("Collapse");
            }
            else {
                $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
                $("#spanExpandAll").text("Expand");
            }
        }
        function ExpandAllTreeView() {
            $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
        }
        function SearchTreeView() {
            $('#jsTreeAreaLevel').treeview('search', ['Parent', {
                ignoreCase: true,
                exactMatch: false,
                revealResults: true,
            }]);
        }

        function InitiateLevelTree() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getJsTreeAreaLevel = {
                    url: "/api/Configuration/GetEALData",
                    type: "GET",
                    data: { RiskAreType: SrViewModel.ClickedSurveyTypeText(), SurveyCategoryID: SrViewModel.Zat_id_Tree().toString(), AssessmentTypes: SrViewModel.AssessmentTypeId().toString(), ScreenType: 'RA' },
                    headers: headers
                };
                $.ajax(getJsTreeAreaLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                if (jsonResult != null) {
                    //implement js tree logic here
                    SrViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);
                    var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                        return new jsTreeModel(result);
                    });

                    $('#jsTreeAreaLevel').treeview({
                        data: MappedJsTreeList,
                        onNodeSelected: nodeClickEvent
                    });
                    //for initial load expand for treeview
                    $("#jsTreeAreaLevel ul:first li:first").trigger("click");
                    $("loadingImgOrCalc").hide();
                    $("loadingMainImgDiv").hide();

                }
            }

            function nodeClickEvent(event, node) {
                try {
                // Your logic goes here
                SrViewModel.Type(node.RA_Type());
                if (node.dead_node == 1) {
                    $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);

                    SrViewModel.ClickedRiskAreaId(parseInt(node.id));
                    SrViewModel.ClickedRiskAreaName($('<div/>').html(node.text).text());

                    if (SrViewModel.ClickedSurveyTypeText().toLowerCase() == 'qldr') {
                        GetQualResponseDetails(SrViewModel.Zat_id_Tree());
                    }
                    else {
                        GetControlResponseDetails(SrViewModel.Zat_id_Tree());
                    }

                } else {
                    //recursively opening until the dead_node arrives.
                    if (!(node.state.expanded))
                        nodeClickEvent(event, node.nodes[0]);
                    $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                    $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);
                }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }

        function jsTreeModel(item) {
            var self = this;

            self.id = item.AreaLevelId.toString();
            self.text = item.AreaLevelName;
            if (SrViewModel.AreaLeveljstree()[self.id].length > 0) {
                self.nodes = $.map(SrViewModel.AreaLeveljstree()[self.id], function (result) {
                    return new jsTreeModel(result);
                });
            }
            self.state = { expanded: false };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
            self.RA_Type = ko.observable(item.RA_Type);
        }
         //////////////////////////////// --- Tree view code till here---- ///////////////////////////////////


        //--Report link code-- //
        function NavigateToSocioExportReport(data) {
            try {

                $('#loadingMainImgDivHm').show();
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), OrgLevel: SrViewModel.BusinessUnitId()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/ExportSocializationReportToExcel", payLoad, '_blank');
                $('#loadingMainImgDivHm').hide();

            }
            catch (e) {
                var msg = 'exception' + e + 'source in ViewReport() in SR.js';
                logger.logMessage(msg);
            }
        }

        function NavigateToSocioHistoricExportReport(data) {
            try {

                $('#loadingMainImgDivHm').show();
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), OrgLevel: SrViewModel.BusinessUnitId()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/ExportSocializationHistoricReportToExcel", payLoad, '_blank');
                $('#loadingMainImgDivHm').hide();

            }
            catch (e) {
                var msg = 'exception' + e + 'source in ViewReport() in SR.js';
                logger.logMessage(msg);
            }
        }

        //Qualitative request accordian code
        function RequestedQAAccordionClick(data, event) {
            try {
                if ($('#ATDataDiv').is(':visible')) {
                    $('#ATDataDiv').hide();
                }
                else {
                    $('#ATDataDiv').show();
                }
            }
            catch (e) {
                var msg = 'exception' + e + 'source in RequestedQAAccordionClick() in RS.js';
                logger.logMessage(msg);
            }
        }


        function RecalculateAccordionClick(data, event) {
            try {
                if ($('#SGDataDiv').is(':visible')) {
                    $('#SGDataDiv').hide();
                }
                else {
                    $('#SGDataDiv').show();
                }
            }
            catch (e) {
                var msg = 'exception' + e + 'source in RecalculateAccordionClick() in RS.js';
                logger.logMessage(msg);
            }
        }

        function DisplayExportDropdown(data, event) {
            $('#myValueDropdownLevel').removeClass('show');
            $('#myValueDropdownSortLevel').removeClass('open');
            $('#myDropdown').removeClass('show')
            $('#myDropdownSort').removeClass('open')
            $('#myValueDropdown').removeClass('show')
            $('#myValueDropdownSort').removeClass('open')

            document.getElementById("ReportLinkDiv").classList.toggle("show");
            document.getElementById("ReportLinkDivBtn").classList.toggle("open");
        }

    }); //closing tag of page top element
;
